export let homeList = [
  {
    id: 'Massager009',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/9.jpg"),
    obj1: {
      title: 'Deep muscle relaxation exercise massage fascia gun, daily portable massage device',
      money: '189.95',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Fitness Effect', value: 'Muscle Relaxation' },
        { label: 'Max Power', value: '49W' },
        { label: 'Rated Voltage', value: '12V' },
        { label: 'No-load Power', value: '27W' },
        { label: 'Massage Head Material', value: 'Polyurethane Foam' },
        { label: 'Net Weight', value: '920g' },
        { label: 'Motor Type', value: 'Brushless Motor' },
        { label: 'Battery Capacity', value: '2400mAh' },
        { label: 'Power Supply', value: 'Rechargeable' },
        { label: 'Body Width', value: '74mm' },
        { label: 'Energy Consumption', value: '21Wh' },
        { label: 'Application Scenario', value: 'Sports' },
        { label: 'Professional Level', value: 'Fitness Grade' },
        { label: 'Warranty Period', value: '1 Year' },
        { label: 'Heat Function', value: 'No Heat Support' },
        { label: 'Color', value: 'Black' },
        { label: 'Body Length', value: '223mm' },
        { label: 'Amplitude Depth', value: '16mm' },
        { label: 'Number of Gears', value: '5 Gears' },
        { label: 'Battery Life', value: '120 Minutes' },
        { label: 'Max Speed', value: '2400 RPM' },
        { label: 'Charging Method', value: 'Type-C' },
        { label: 'Body Height', value: '210mm' },
        { label: 'Number of Massage Heads', value: '4' },
        { label: 'Target User', value: 'Universal' },
        { label: 'Waterproof Rating', value: 'No Waterproof Function' },
        { label: 'Massage Mode', value: 'Pulse Mode' },
        { label: 'Applicable Body Parts', value: 'Full Body' }
      ],
      imgs: [
        require("../assets/images/Massager/9.jpg"),
        require("../assets/images/Massager/9.1.jpg"),
        require("../assets/images/Massager/9.2.jpg"),
        require("../assets/images/Massager/9.3.jpg"),
        require("../assets/images/Massager/9.4.jpg"),
        require("../assets/images/Massager/9.5.jpg"),
      ]
    },
  },
  {
    id: 'Massager001',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/1.png"),
    obj1: {
      title: 'Adjustable Home Theater with Eight Point Massager Function and Heated in Black PU',
      money: '1000.00',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Brand Name', value: 'Generic' },
        { label: 'Recommended Uses For Product', value: 'Home Theater' },
        { label: 'Age Range Description', value: 'Adult' },
        { label: 'Included Components', value: 'Remote control' },
        { label: 'Model Name', value: 'Massage Chair' },
        { label: 'Surface Recommendation', value: 'Hard Floor' },
        { label: 'Model Number', value: '417845' },
        { label: 'Unit Count', value: '1.0 Count' },
        { label: 'Item Type Name', value: 'Chairs' },
        { label: 'Color', value: 'Black' },
        { label: 'Pattern', value: 'Solid' },
        { label: 'Shape', value: 'Square' },
        { label: 'Item Dimensions D x W x H', value: '22.83"D x 33.98"W x 43.31"H' },
        { label: 'Item Weight', value: '82.2 Pounds' },
        { label: 'Item Dimensions', value: '22.83 x 33.98 x 43.31 inches' },
        { label: 'Unit Count', value: '1.0 Count' },
        { label: 'Seat Depth', value: '22.83 inches' }
      ],
      imgs: [
        require("../assets/images/Massager/1.png"),
        require("../assets/images/Massager/1.1.png"),
        require("../assets/images/Massager/1.2.png"),
        require("../assets/images/Massager/1.3.png")
      ]
    },
  },
  {
    id: 'Massager002',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/2.png"),
    obj1: {
      title: 'Foot massage device with heating function, acupressure foot massage device suitable for plantar fasciitis, cordless control, FSA compliant',
      money: '279.00',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Use for', value: 'Feet, Foot' },
        { label: 'Target Use Body Part', value: 'Feet, Foot' },
        { label: 'Power Source', value: 'Corded Electric' },
        { label: 'Material', value: 'Plastic' },
        { label: 'Item Weight', value: '3.85 Kilograms' },
        { label: 'Other Special Features of the Product', value: 'christmas gifts men women stocking stuffers for lover birthday gifts for women gifts for men best selling items for moms gifts for mom gifts for dad anniversary gifts.' },
        { label: 'Massager Form', value: 'Foot Massager Machine' },
        { label: 'Specific Uses For Product', value: 'Plantar Fasciitis' },
        { label: 'Product Benefits', value: 'Fatigue Relief, Metabolism Improvement, Pain Relief, Stress Relief, foot massager' },
        { label: 'Is Product Cordless', value: 'No' },
        { label: 'Product Grade', value: 'New' },
        { label: 'Water Resistance Level', value: 'Not Water Resistant' },
        { label: 'Massage Therapy Technique', value: 'Compression, Kneading, Rolling, Shiatsu' }
      ],
      imgs: [
        require("../assets/images/Massager/2.png"),
        require("../assets/images/Massager/2.1.png"),
        require("../assets/images/Massager/2.2.png"),
        require("../assets/images/Massager/2.3.png")
      ]
    },
  },
  {
    id: 'Massager003',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/3.jpg"),
    obj1: {
      title: 'Massage cushion, lumbar and back massage device, lumbar muscle and cervical vertebra pillow therapy, fully automatic massage chair',
      money: '311.00',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Appearance Shape', value: 'Rectangular Trapezoid' },
        { label: 'Massage Techniques', value: 'Tapping, Vibration, Kneading, Tui Na, Patting' },
        { label: 'Power Supply Mode', value: 'AC Power' },
        { label: 'Physiotherapy Type', value: 'Hot Compress' },
        { label: 'Control Mode', value: 'Mechanical' },
        { label: 'Warranty Period', value: '24 Months' },
        { label: 'Applicable Body Parts', value: 'Back, Legs, Feet, Neck, Buttocks, Waist' },
        { label: 'Number of Airbags', value: '10 or less' },
        { label: 'Product Category', value: 'Massage Cushion' },
        { label: 'Charging Method', value: 'AC Power Supply' },
        { label: 'Category', value: 'Massage Cushion' },
        { label: 'Number of Massage Nodes', value: '5 (inclusive) - 7 (inclusive)' }
      ],
      imgs: [
        require("../assets/images/Massager/3.jpg"),
        require("../assets/images/Massager/3.1.jpg"),
        require("../assets/images/Massager/3.2.jpg"),
        require("../assets/images/Massager/3.3.jpg"),
        require("../assets/images/Massager/3.4.jpg"),
        require("../assets/images/Massager/3.5.jpg")
      ]
    },
  },
  {
    id: 'Massager004',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/4.jpg"),
    obj1: {
      title: 'Leg massage device, fully automatic kneading and massaging device for calf, foot, and sole, foot therapy machine, massage instrument',
      money: '230.00',
      color: ['Champagne Gold'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Brand Name', value: 'Generic' },
        { label: 'Functions', value: 'Leg Massage, Infrared Sterilization, Vibration Massage, Roller Massage, Airbag Massage' },
        { label: 'Warranty Period', value: '12 Months' },
        { label: 'Smart Type', value: 'Other Smart' },
        { label: 'Massage Body Parts', value: 'Calf + Foot' },
        { label: 'Color Variation', value: 'Champagne Gold' }
      ],
      imgs: [
        require("../assets/images/Massager/4.jpg"),
        require("../assets/images/Massager/4.1.jpg"),
        require("../assets/images/Massager/4.2.jpg"),
        require("../assets/images/Massager/4.3.jpg"),
        require("../assets/images/Massager/4.4.jpg")
      ]
    },
  },
  {
    id: 'Massager005',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/5.jpg"),
    obj1: {
      title: 'Cervical Massager, Shoulder and Neck Massager',
      money: '141.99',
      color: ['Cyan-Blue'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Heating Method', value: 'Heating Sheet' },
        { label: 'Massage Techniques', value: 'Pinching, Tapping' },
        { label: 'Power Supply Mode', value: 'Rechargeable' },
        { label: 'Physiotherapy Type', value: 'Stretching' },
        { label: 'Voltage', value: '12V' },
        { label: 'Control Mode', value: 'Button Control' },
        { label: 'Warranty Period', value: '24 Months' },
        { label: 'Smart Type', value: 'Non-smart' },
        { label: 'Shape', value: 'U-Shape' },
        { label: 'Applicable Body Parts', value: 'Trapezius, Scapula, Neck & Shoulder, Neck' },
        { label: 'Color Variation', value: 'Cyan Blue' }
      ],
      imgs: [
        require("../assets/images/Massager/5.jpg"),
        require("../assets/images/Massager/5.1.jpg"),
        require("../assets/images/Massager/5.2.jpg"),
        require("../assets/images/Massager/5.3.jpg"),
      ]
    },
  },
  {
    id: 'Massager006',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/6.jpg"),
    obj1: {
      title: 'Massage pad for home use, full-body kneading and stretching pad, leg and foot massage device, folding massage chair',
      money: '509.95',
      color: ['brown'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Installation', value: 'No Installation Required' },
        { label: 'Movement Type', value: 'Multi-point Tui Na Massage' },
        { label: 'Heating Areas', value: 'Foot Heating, Back Heating, Waist Heating' },
        { label: 'Warranty Period', value: '24 Months' },
        { label: 'Smart Type', value: 'Other Smart' },
        { label: 'Applicable Body Parts', value: 'Legs, Back, Neck, Feet' },
        { label: 'Chair Type', value: 'Foldable Massage Chair' },
        { label: 'Massage Techniques', value: 'Stretching, Kneading' },
        { label: 'Rail Type', value: 'No Rail' },
        { label: 'Number of Airbags', value: '31 (inclusive) - 60 (inclusive)' },
        { label: 'Functions', value: 'Airbag Intensity Adjustment, Massage Intensity Adjustment, Local Heat Therapy' },
        { label: 'Control Method', value: 'Wired Remote Control' },
        { label: 'Color Variation', value: 'Coffee' }
      ],
      imgs: [
        require("../assets/images/Massager/6.jpg"),
        require("../assets/images/Massager/6.1.jpg"),
        require("../assets/images/Massager/6.2.jpg"),
        require("../assets/images/Massager/6.3.jpg"),
        require("../assets/images/Massager/6.4.jpg")
      ]
    },
  },
  {
    id: 'Massager007',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/7.jpg"),
    obj1: {
      title: 'Massage foot soaking bucket, fully automatic foot therapy machine, calf massage, foot bath boots, foot kneading device',
      money: '169.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'For', value: 'Calf + Foot' },
        { label: 'Target Body Part', value: 'Calf + Foot' },
        { label: 'Power Supply', value: 'Plug-in' },
        { label: 'Product Benefits', value: 'Fatigue Relief, Metabolism Boost, Pain Relief, Stress Relief, Foot Massage' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Model', value: 'Water Bath Boots' },
        { label: 'Functions', value: 'Leg Massage, Foot Massage' },
        { label: 'Voltage', value: '220V' },
        { label: 'Warranty', value: '12 Months' },
        { label: 'Massage Area', value: 'Calf + Foot' },
        { label: 'Color', value: 'White' }
      ],
      imgs: [
        require("../assets/images/Massager/7.jpg"),
        require("../assets/images/Massager/7.1.jpg"),
        require("../assets/images/Massager/7.2.jpg"),
        require("../assets/images/Massager/7.3.jpg")
      ]
    },
  },
  {
    id: 'Massager008',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/8.jpg"),
    obj1: {
      title: 'Octopus head massager, head massage device, automatic scalp massager, electric head massager',
      money: '135.95',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Functions', value: 'Timer, Music Function, Sleep Aid' },
        { label: 'Voltage', value: '100-240V Universal' },
        { label: 'Warranty Period', value: '3 Years' },
        { label: 'Massage Principle', value: 'Vibration' },
        { label: 'Model', value: 'BLEES398' },
        { label: 'Power Supply Mode', value: 'USB, Lithium Battery, Rechargeable' },
        { label: 'Color Variation', value: 'Black' },
        { label: 'Applicable Body Part', value: 'Head' },
        { label: 'Product Benefits', value: 'Fatigue Relief, Stress Relief' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Massage Area', value: 'Head' }
      ],
      imgs: [
        require("../assets/images/Massager/8.jpg"),
        require("../assets/images/Massager/8.1.jpg"),
        require("../assets/images/Massager/8.2.jpg"),
        require("../assets/images/Massager/8.3.jpg")
      ]
    },
  },
  {
    id: 'Massager010',
    type: 'Beauty',
    homeImg: require("../assets/images/Massager/10.png"),
    obj1: {
      title: '6-in-1 Real Glass Radiant Beauty Massager | For Clean, Radiant, and Firm Skin | Pink',
      money: '220.00',
      color: ['Pink'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color', value: 'Pink' },
        { label: 'Item Weight', value: '155 Grams' },
        { label: 'Material', value: 'Silicone' },
        { label: 'Skin Type', value: 'All' },
        { label: 'Power Source', value: 'Battery Powered' },
        { label: 'Warranty', value: '1 Year' },
        { label: 'Unit Count', value: '1.0 Count' },
        { label: 'Product Benefits', value: 'Aging, Blemish, Pore Care, Pigmentation, Skin Texture, Skin Tone' },
        { label: 'Included Components', value: 'Instruction Manual, USB Charging Cable' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Applicable Body Part', value: 'Face' }
      ],
      imgs: [
        require("../assets/images/Massager/10.png"),
        require("../assets/images/Massager/10.1.png"),
        require("../assets/images/Massager/10.2.png"),
        require("../assets/images/Massager/10.3.png"),
        require("../assets/images/Massager/10.4.png"),
      ]
    },
  },
  {
    id: 'Massager011',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/11.png"),
    obj1: {
      title: 'Foot massage device with heating function, acupressure foot massage device suitable for plantar fasciitis, cordless control.',
      money: '99.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Target User', value: 'Universal' },
        { label: 'Color', value: 'White' },
        { label: 'Material', value: 'Plastic' },
        { label: 'Applicable Body Parts', value: 'Back, Neck, Shoulder' },
        { label: 'Power Supply', value: 'Battery Powered' },
        { label: 'Cordless', value: 'Yes' },
        { label: 'Product Grade', value: 'Brand New, Home Use' },
        { label: 'Massager Form', value: 'Wrap Around Neck Massager' },
        { label: 'Massage Technique', value: 'Acupressure' },
        { label: 'Quantity', value: '1 Piece' }
      ],
      imgs: [
        require("../assets/images/Massager/11.png"),
        require("../assets/images/Massager/11.1.png"),
        require("../assets/images/Massager/11.2.png"),
        require("../assets/images/Massager/11.3.png")
      ]
    },
  },
  {
    id: 'Massager012',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/12.png"),
    obj1: {
      title: 'Massage cushion for back, waist, cervical spine, full-body multi-function massage device, chair cushion, car-mounted, household use',
      money: '209.95',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Appearance', value: 'Rectangular Trapezoid' },
        { label: 'Massage Techniques', value: 'Acupressure, Kneading, Tapping' },
        { label: 'Power Supply', value: 'AC Power, Car Power' },
        { label: 'Physiotherapy Type', value: 'Hot Compress' },
        { label: 'Control Mode', value: 'Mechanical' },
        { label: 'Warranty Period', value: '12 Months' },
        { label: 'Smart Function', value: 'Other Smart Features' },
        { label: 'Applicable Parts', value: 'Back, Neck, Hip, Waist' },
        { label: 'Airbag Quantity', value: '10 or Less' },
        { label: 'Product Category', value: 'Massage Cushion' },
        { label: 'Charging Method', value: 'AC Power Supply' },
        { label: 'Type', value: 'Massage Seat Cushion' },
        { label: 'Massage Head Quantity', value: '8 or More' },
        { label: 'Color', value: 'Gray' }
      ],
      imgs: [
        require("../assets/images/Massager/12.png"),
        require("../assets/images/Massager/12.1.png"),
        require("../assets/images/Massager/12.2.png"),
        require("../assets/images/Massager/12.3.png"),
        require("../assets/images/Massager/12.4.png"),
      ]
    },
  },
  {
    id: 'Massager013',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/13.png"),
    obj1: {
      title: 'Negative ion eye massage device, eye protection device, hot compress eye bag, black eye circles, eye mask, eye care device',
      money: '116.95',
      color: ['Silvery'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Power Supply', value: 'Rechargeable, Battery' },
        { label: 'Massage Principle', value: 'Vibration, Air Pressure, Hot Compress' },
        { label: 'Core Functions', value: 'Hot Compress, Airbag Kneading' },
        { label: 'Voltage', value: '220V' },
        { label: 'Smart Type', value: 'Other Smart' },
        { label: 'Warranty Period', value: '12 Months' },
        { label: 'Applicable Parts', value: 'Eyes' },
        { label: 'Target Users', value: 'Universal' },
        { label: 'Foldable', value: 'Yes' },
        { label: 'Product Category', value: 'Eye Massager' },
        { label: 'Functions', value: 'Hot Compress' },
        { label: 'Applicable Symptoms', value: 'Eye Bags, Eye Fatigue' },
        { label: 'Color Category', value: 'Negative Ion Eye Care Device' }
      ],
      imgs: [
        require("../assets/images/Massager/13.png"),
        require("../assets/images/Massager/13.1.png"),
        require("../assets/images/Massager/13.2.png"),
        require("../assets/images/Massager/13.3.png"),
        require("../assets/images/Massager/13.4.png"),
      ]
    },
  },
  {
    id: 'Massager014',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/14.png"),
    obj1: {
      title: 'Electric hot compress sea salt bag for shoulder, neck, waist, and abdomen protection, universal mugwort electric heating belt',
      money: '49.95',
      color: ['Beige'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Target User', value: 'Universal' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Power Supply', value: 'AC Power' },
        { label: 'Voltage', value: '220V' },
        { label: 'Control Mode', value: 'Mechanical' },
        { label: 'Warranty Period', value: '12 Months' },
        { label: 'Shape', value: 'Rectangle' },
        { label: 'Color Category', value: 'Beige' },
        { label: 'Fabric Material', value: 'Other' },
        { label: 'Applicable Parts', value: 'Back, Waist, Hip, Leg, Shoulder' }
      ],
      imgs: [
        require("../assets/images/Massager/14.png"),
        require("../assets/images/Massager/14.1.png"),
        require("../assets/images/Massager/14.2.png"),
        require("../assets/images/Massager/14.3.png"),
        require("../assets/images/Massager/14.4.png")
      ]
    },
  },
  {
    id: 'Massager015',
    type: 'Beauty',
    homeImg: require("../assets/images/Massager/15.png"),
    obj1: {
      title: 'Steam face instrument, cold and hot dual spray, nano spray, hydrating instrument, household facial moisturizing',
      money: '69.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Efficacy', value: 'Hydration' },
        { label: 'After-sales Service', value: 'Store Warranty' },
        { label: 'Power Supply', value: 'Plug-in Power' },
        { label: 'Spray Temperature', value: 'Hot Spray, Cold Spray, Hot & Cold Spray' },
        { label: 'Mist Generation Time', value: 'Within 10 Seconds' },
        { label: 'Smart Type', value: 'Other Smart' },
        { label: 'Spray Water Source', value: 'Purified Water' },
        { label: 'Application Scenario', value: 'Home Use' },
        { label: 'Color Category', value: 'White' },
        { label: 'Target User', value: 'Universal' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
      ],
      imgs: [
        require("../assets/images/Massager/15.png"),
        require("../assets/images/Massager/15.1.png"),
        require("../assets/images/Massager/15.2.png"),
        require("../assets/images/Massager/15.3.png"),
        require("../assets/images/Massager/15.4.png"),
      ]
    },
  },
  {
    id: 'Massager016',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/16.jpg"),
    obj1: {
      title: 'Fascia gun muscle massager 16-head electric massage device waist and leg relaxation device',
      money: '116.95',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Massage Technique', value: 'Vibration' },
        { label: 'Power Supply', value: 'Battery' },
        { label: 'Model', value: 'TR-99' },
        { label: 'Voltage', value: '100-240V Universal' },
        { label: 'Control Mode', value: 'Button Control' },
        { label: 'Heating Method', value: 'No Heating' },
        { label: 'Color Category', value: 'Gray' },
        { label: 'Target User', value: 'Universal' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Applicable Parts', value: 'Neck, Legs, Waist' }
      ],
      imgs: [
        require("../assets/images/Massager/16.jpg"),
        require("../assets/images/Massager/16.1.jpg"),
        require("../assets/images/Massager/16.2.jpg"),
        require("../assets/images/Massager/16.3.jpg"),
        require("../assets/images/Massager/16.4.jpg"),
        require("../assets/images/Massager/16.5.jpg"),
      ]
    },
  },
  {
    id: 'Massager017',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/17.jpg"),
    obj1: {
      title: 'Professional 3D physical therapy device, multi-head fascia gun, medical sports rehabilitation and muscle massage device.',
      money: '289.99',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Fitness Effect', value: 'Muscle Relaxation' },
        { label: 'Max Power', value: '40W' },
        { label: 'Body Material', value: 'Metal' },
        { label: 'No-load Power', value: '8W' },
        { label: 'Massage Head Material', value: 'Silicone' },
        { label: 'Motor Type', value: 'Brushless Motor' },
        { label: 'Battery Capacity', value: '2900mAh' },
        { label: 'Power Supply', value: 'Rechargeable' },
        { label: 'Working Time', value: '3 Hours' },
        { label: 'Energy Consumption', value: '6Wh' },
        { label: 'Application Scenario', value: 'Sports' },
        { label: 'Professional Level', value: 'Professional Grade' },
        { label: 'Warranty Period', value: '1 Year' },
        { label: 'Hot Compress Function', value: 'Not Supported' },
        { label: 'Amplitude Depth', value: '3mm' },
        { label: 'Number of Gears', value: '4 Gears' },
        { label: 'Battery Life', value: '240 Minutes' },
        { label: 'Max Speed', value: '6500 RPM' },
        { label: 'Charging Method', value: 'Type-C' },
        { label: 'Number of Massage Heads', value: '4' },
        { label: 'Smart Type', value: 'Other Smart' },
        { label: 'Target User', value: 'Universal' },
        { label: 'Waterproof Level', value: 'No Waterproof Function' },
        { label: 'Massage Mode', value: 'Continuous Mode' },
        { label: 'Applicable Parts', value: 'Full Body' }
      ],
      imgs: [
        require("../assets/images/Massager/17.jpg"),
        require("../assets/images/Massager/17.1.jpg"),
        require("../assets/images/Massager/17.2.jpg"),
        require("../assets/images/Massager/17.3.jpg"),
        require("../assets/images/Massager/17.4.jpg"),
        require("../assets/images/Massager/17.5.jpg"),
      ]
    },
  },
  {
    id: 'Massager018',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/18.jpg"),
    obj1: {
      title: 'Waist massager, lumbar muscle strain massage device, traction device, lumbar disc herniation physical therapy massage device',
      money: '169.95',
      color: ['Blue'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color', value: 'Blue' },
        { label: 'Massage Technique', value: 'Stretching, Vibration' },
        { label: 'Power Supply', value: 'AC Power' },
        { label: 'Physiotherapy Mode', value: 'Low Frequency Pulse' },
        { label: 'Voltage', value: '100-240V Universal' },
        { label: 'Applicable Parts', value: 'Waist' },
        { label: 'Warranty Period', value: '1 Year' },
        { label: 'Smart Type', value: 'Other Smart' },
        { label: 'Control Mode', value: 'Remote Control' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Applicable Parts', value: 'Waist' }
      ],
      imgs: [
        require("../assets/images/Massager/18.jpg"),
        require("../assets/images/Massager/18.1.jpg"),
        require("../assets/images/Massager/18.2.jpg"),
        require("../assets/images/Massager/18.3.jpg"),
        require("../assets/images/Massager/18.4.jpg"),
        require("../assets/images/Massager/18.5.jpg"),
      ]
    },
  },
  {
    id: 'Massager019',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/19.jpg"),
    obj1: {
      title: 'Deep muscle stimulator, exercise fitness muscle loosening device, professional grade fascia gun',
      money: '132.95',
      color: ['Blue'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Power Supply', value: 'Plug-in Type' },
        { label: 'Body Material', value: 'Metal' },
        { label: 'Main Body Size', value: '240x100x50mm' },
        { label: 'Product Name', value: 'Deep Muscle Stimulator' },
        { label: 'Warranty Period', value: '12 Months' },
        { label: 'Application Scenario', value: 'Sports, Gym' },
        { label: 'Massage Head Material', value: 'Silicone' },
        { label: 'Professional Level', value: 'Professional Grade' },
        { label: 'Target User', value: 'Adults' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Massage Mode', value: 'Variable Frequency Massage Mode' },
        { label: 'Applicable Parts', value: 'Full Body' },
        { label: 'Color Category', value: 'Blue' }
      ],
      imgs: [
        require("../assets/images/Massager/19.jpg"),
        require("../assets/images/Massager/19.1.jpg"),
        require("../assets/images/Massager/19.2.png"),
        require("../assets/images/Massager/19.3.jpg"),
      ]
    },
  },
  {
    id: 'Massager020',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/20.png"),
    obj1: {
      title: 'Massage chair, space capsule, household full-body intelligent massage, fully automatic electric sofa',
      money: '999.95',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Lining Material', value: 'PU Leather' },
        { label: 'Color', value: 'Blue' },
        { label: 'Massage Techniques', value: 'Imitated Hand Kneading, Tapping, Patting' },
        { label: 'Max User Height', value: '1.9m' },
        { label: 'Max User Weight', value: '150kg' },
        { label: 'Massage Programs', value: '24 Sets' },
        { label: 'Number of Airbags', value: '32' },
        { label: 'Control Method', value: 'Touch Screen' },
        { label: 'Power Cord Length', value: '1.9m' },
        { label: 'Net Weight', value: '103kg' },
        { label: 'Product Size', value: 'L1610mm x W790mm x H1235mm' },
        { label: 'Outer Package Size', value: 'L146cm x W81cm x H127cm' },
        { label: 'Rated Voltage', value: '220V' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Guide Rail', value: 'SL Guide Rail' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Unit Structure', value: 'Integrated' },
        { label: 'Type', value: 'Home Massage Chair' },
        { label: 'Movement', value: '3D' },
        { label: 'Functions', value: 'Zero Gravity, Local Hot Compress' },
      ],
      imgs: [
        require("../assets/images/Massager/20.png"),
        require("../assets/images/Massager/20.1.png"),
        require("../assets/images/Massager/20.2.png"),
        require("../assets/images/Massager/20.3.png"),
        require("../assets/images/Massager/20.4.png"),
      ]
    },
  },
  {
    id: 'Massager021',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/21.jpg"),
    obj1: {
      title: 'High speed fascia gun professional competition deep muscle massager neck membrane fitness massage gun',
      money: '111.95',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Max Power", value: "35W" },
        { label: "No-load Power", value: "35W" },
        { label: "Massage Head Material", value: "Silicone" },
        { label: "Net Weight", value: "850g" },
        { label: "Motor Type", value: "Brushless Motor" },
        { label: "Gross Weight", value: "1100g" },
        { label: "Power Supply", value: "Rechargeable" },
        { label: "Body Width", value: "58mm" },
        { label: "Application Scenario", value: "Sports" },
        { label: "Professional Level", value: "Professional Grade" },
        { label: "Hot Compress Function", value: "Not Supported" },
        { label: "Color", value: "Black" },
        { label: "Body Length", value: "185mm" },
        { label: "Amplitude Depth", value: "13mm" },
        { label: "Number of Gears", value: "6 Gears" },
        { label: "Battery Life", value: "90 Minutes" },
        { label: "Body Height", value: "178mm" },
        { label: "Number of Massage Heads", value: "4" },
        { label: "Suitable For", value: "Universal" },
        { label: "Handle Design", value: "Non-slip Handle + Smart Pressure Sensor System" },
        { label: "Massage Mode", value: "Variable Frequency Massage Mode" },
        { label: "Applicable Body Parts", value: "Full Body" }
      ],
      imgs: [
        require("../assets/images/Massager/21.jpg"),
        require("../assets/images/Massager/21.1.jpg"),
        require("../assets/images/Massager/21.2.jpg"),
        require("../assets/images/Massager/21.3.jpg"),
        require("../assets/images/Massager/21.4.jpg"),
        require("../assets/images/Massager/21.5.jpg"),
      ]
    },
  },
  {
    id: 'Massager022',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/22.jpg"),
    obj1: {
      title: 'Massage Chair Fully Automatic Intelligent Electric Massage Chair Home Full Body Massage 2026 New Product',
      money: '928.99',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Voltage", value: "220V" },
        { label: "Arm Massage Method", value: "Widened Arm Airbag" },
        { label: "Shoulder Massage Method", value: "Double Layer Shoulder Airbag Massage" },
        { label: "Smart Control", value: "No" },
        { label: "Applicable Parts", value: "Legs, Back, Arms, Neck, Feet, Full Body, Hips, Waist, Shoulders" },
        { label: "Chair Type", value: "Massage Chair" },
        { label: "Massage Techniques", value: "Acupressure, Percussion, Kneading, Stretching, Tui Na, Tapping" },
        { label: "Fabric Material", value: "Skin-friendly Soft Leather" },
        { label: "Additional Functions", value: "Bluetooth Connection, Built-in Speaker, Ambient Light" },
        { label: "Number of Airbags", value: "31 - 60 pcs" },
        { label: "Foot Massage", value: "Yes" },
        { label: "Color", value: "White" },
        { label: "Movement Type", value: "4.0 Air Suspension Movement" },
        { label: "Heating Areas", value: "Waist Heating, Foot Surface Heating" },
        { label: "Warranty", value: "36 Months" },
        { label: "Smart Type", value: "Body Detection" },
        { label: "Guide Rail Type", value: "SL Guide Rail" },
        { label: "Hip Massage Method", value: "Manipulator Kneading + Airbag Hip Clamping Massage" },
        { label: "Functions", value: "Massage Point Adjustment, Airbag Intensity Adjustment, Local Heat Therapy, Massage Intensity Adjustment, Bluetooth Connection, Automatic Detection, Roller Speed Adjustment" },
        { label: "Control Method", value: "Wired Remote Control, Touch Screen" },
        { label: "Installation", value: "No Installation Required" },
        { label: "Foot Massage Method", value: "Three-row Roller Massage + Heel Clamping" }
      ],
      imgs: [
        require("../assets/images/Massager/22.jpg"),
        require("../assets/images/Massager/22.1.jpg"),
        require("../assets/images/Massager/22.2.jpg"),
        require("../assets/images/Massager/22.3.jpg"),
        require("../assets/images/Massager/22.4.jpg"),
        require("../assets/images/Massager/22.5.jpg"),
      ]
    },
  },
  {
    id: 'Massager023',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/23.jpg"),
    obj1: {
      title: 'High end massage chair, fully automatic full body luxury space cabin massage sofa',
      money: '920.99',
      color: ['Blue'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Logistics & Installation", value: "Door-to-door delivery, no installation required" },
        { label: "Movement Type", value: "5D Movement" },
        { label: "Warranty Period", value: "36 months" },
        { label: "Arm Massage Method", value: "U-shaped widened arm airbag" },
        { label: "Smart Type", value: "Health detection + optocoupler body detection" },
        { label: "Smart Control", value: "Yes" },
        { label: "Shoulder Massage Method", value: "Tool-free shoulder massage" },
        { label: "Applicable Parts", value: "Legs, Arms, Neck, Feet, Full Body, Hips, Waist, Shoulders" },
        { label: "Chair Type", value: "Massage Chair" },
        { label: "Guide Rail Type", value: "SL Guide Rail" },
        { label: "Number of Airbags", value: "61 to 80 pieces" },
        { label: "Functions", value: "Massage point adjustment, airbag intensity adjustment, local heat therapy, massage intensity adjustment, Bluetooth connection, roller speed adjustment, automatic detection function" },
        { label: "Hip Massage Method", value: "Tui Na, kneading, tapping, pulling + airbag hip clamping massage" },
        { label: "Control Method", value: "Voice, touch screen, button type" },
        { label: "Installation Method", value: "No installation required" },
        { label: "Foot Massage Method", value: "Full airbag wrapping + innovative rubbing and scraping" },
        { label: "Color", value: "Mechanical Blue" }
      ],
      imgs: [
        require("../assets/images/Massager/23.jpg"),
        require("../assets/images/Massager/23.1.jpg"),
        require("../assets/images/Massager/23.2.jpg"),
        require("../assets/images/Massager/23.3.jpg"),
        require("../assets/images/Massager/23.4.jpg"),
      ]
    },
  },
  {
    id: 'Massager024',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/24.jpg"),
    obj1: {
      title: 'Shoulder and neck massager, trapezius muscle hot compress shoulder and neck massager, fully automatic kneading and kneading',
      money: '46.95',
      color: ['Brown'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Massage Techniques", value: "Hot compress, Acupressure, Pinching, Kneading" },
        { label: "Physiotherapy Type", value: "Kneading" },
        { label: "Control Method", value: "Button control" },
        { label: "Shape", value: "Square / Round square" },
        { label: "Applicable Parts", value: "Trapezius, Legs, Back, Shoulder & Neck, Waist" },
        { label: "Color", value: "Brown" }
      ],
      imgs: [
        require("../assets/images/Massager/24.jpg"),
        require("../assets/images/Massager/24.1.jpg"),
        require("../assets/images/Massager/24.2.jpg"),
        require("../assets/images/Massager/24.3.jpg"),
      ]
    },
  },
  {
    id: 'Massager025',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/25.jpg"),
    obj1: {
      title: 'Fully automatic home kneading foot sole foot meridian massage foot therapy machine',
      money: '216.99',
      color: ['dark gray'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Function", value: "Leg massage" },
        { label: "Voltage", value: "220V" },
        { label: 'Rated Voltage', value: '220V' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Warranty Period", value: "12 months" },
        { label: "Manufacturer", value: "OSPIRIT" },
        { label: "Massage Areas", value: "Calf + Foot" },
        { label: "Color", value: "Dark Grey" }

      ],
      imgs: [
        require("../assets/images/Massager/25.jpg"),
        require("../assets/images/Massager/25.1.jpg"),
        require("../assets/images/Massager/25.2.jpg"),
        require("../assets/images/Massager/25.3.jpg"),
        require("../assets/images/Massager/25.4.jpg"),
      ]
    },
  },
  {
    id: 'Massager026',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/26.jpg"),
    obj1: {
      title: 'Intelligent eye protection device for relieving eye fatigue, massage device, and hot compress',
      money: '69.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Power Supply", value: "Battery" },
        { label: "Massage Principle", value: "Vibration, Air pressure, Hot compress" },
        { label: "Foldable", value: "Yes" },
        { label: "Core Functions", value: "Hot compress, Vibration" },
        { label: "Warranty Period", value: "12 months" },
        { label: "Additional Functions", value: "Portable design" },
        { label: 'Rated Voltage', value: '220V' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Applicable Parts", value: "Eyes" },
        { label: "Applicable Symptoms", value: "Eye fatigue" },
        { label: "Applicable People", value: "All ages" },
        { label: "Color", value: "White" }
      ],
      imgs: [
        require("../assets/images/Massager/26.jpg"),
        require("../assets/images/Massager/26.1.jpg"),
        require("../assets/images/Massager/26.2.jpg"),
        require("../assets/images/Massager/26.3.jpg"),
        require("../assets/images/Massager/26.4.jpg"),
      ]
    },
  },
  {
    id: 'Massager027',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/27.jpg"),
    obj1: {
      title: 'Multi functional lumbar disc massager for treating lumbar pain, curvature protrusion, EMS pulse heating massager',
      money: '182.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Power Supply", value: "Rechargeable" },
        { label: "Massage Principle", value: "Vibration, Air pressure, Hot compress" },
        { label: "Functions", value: "Hot compress, Vibration, Swing" },
        { label: "Warranty Period", value: "12 months" },
        { label: "Additional Functions", value: "Portable design" },
        { label: "Quantity", value: "1 Piece" },
        { label: "Product Grade", value: "Brand New" },
        { label: "Applicable Parts", value: "Waist" },
        { label: "Applicable Symptoms", value: "Waist fatigue" },
        { label: "Applicable People", value: "All ages" },
        { label: "Color", value: "White" }
      ],
      imgs: [
        require("../assets/images/Massager/27.jpg"),
        require("../assets/images/Massager/27.1.jpg"),
        require("../assets/images/Massager/27.2.jpg"),
        require("../assets/images/Massager/27.3.jpg"),
        require("../assets/images/Massager/27.4.jpg"),
        require("../assets/images/Massager/27.5.jpg"),
      ]
    },
  },
  {
    id: 'Massager028',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/28.jpg"),
    obj1: {
      title: 'Massage Chair 4D+4D Dual Movement Home Full body Multi functional Intelligent Electric Space Cabin Luxury',
      money: '1499.95',
      color: ['Grey'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Logistics & Installation", value: "Door-to-door delivery, no installation required" },
        { label: "Movement Type", value: "4DPro precision gear movement + 4D manipulator massage" },
        { label: "Heating Areas", value: "Calf heating, Back heating, Waist heating" },
        { label: "Warranty Period", value: "36 months" },
        { label: "Arm Massage", value: "U-shaped extended large arm airbag" },
        { label: "Intelligent Type", value: "Health detection + Optocoupler body detection" },
        { label: "Intelligent Control", value: "Yes" },
        { label: "Shoulder Massage", value: "Double-layer shoulder airbag massage" },
        { label: "Applicable Parts", value: "Back, Legs, Eyes, Head, Knees, Arms, Neck, Feet, Full body, Hips, Waist, Shoulders" },
        { label: "Chair Type", value: "Massage chair" },
        { label: "Massage Techniques", value: "Acupressure, Tapping, Kneading, Stretching, Massage, Patting" },
        { label: "Rail Type", value: "Thickened carbon steel SSL guide rail" },
        { label: "Additional Functions", value: "Bluetooth, Wireless charging, Built-in speaker, AI voice control, Ambient light" },
        { label: "Airbag Quantity", value: "Up to 30" },
        { label: "Functions", value: "Massage point adjustment, Airbag intensity adjustment, Local heat therapy, Massage intensity adjustment, Bluetooth, Roller speed adjustment, Automatic detection" },
        { label: "Hip Massage", value: "Kneading, Tapping, Lifting + Airbag hip massage" },
        { label: "Control Method", value: "Voice, Touch screen, Button" },
        { label: "Installation", value: "No installation required" },
        { label: "Foot Massage", value: "Three-row roller massage + Heel squeezing" },
        { label: "Color", value: "Gray" }
      ],
      imgs: [
        require("../assets/images/Massager/28.jpg"),
        require("../assets/images/Massager/28.1.jpg"),
        require("../assets/images/Massager/28.2.jpg"),
        require("../assets/images/Massager/28.3.jpg"),
        require("../assets/images/Massager/28.4.jpg"),
        require("../assets/images/Massager/28.5.jpg"),
        require("../assets/images/Massager/28.6.jpg"),
      ]
    },
  },
  {
    id: 'Massager029',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/29.jpg"),
    obj1: {
      title: 'Small household full body massage chair, sofa, multifunctional, fully automatic, intelligent small-sized space cabin',
      money: '530.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Movement Type", value: "3D Precision Steel Gear Movement" },
        { label: "Arm Massage Method", value: "Built-in Arm Airbags" },
        { label: "Smart Control", value: "Yes" },
        { label: "Applicable Parts", value: "Back, Legs, Arms, Neck, Hips, Waist" },
        { label: "Chair Type", value: "Massage Chair" },
        { label: "Weight", value: "60kg" },
        { label: "Massage Techniques", value: "Tapping, Pushing, Kneading, Rolling, Hammering" },
        { label: "Guide Rail Type", value: "SL-type Guide Rail" },
        { label: "Fabric Material", value: "PU, ABS" },
        { label: "Additional Functions", value: "Mobile Phone Charging / USB Charging" },
        { label: "Airbag Count", value: "31 (inclusive) - 60 (inclusive)" },
        { label: "Buttock Massage Method", value: "Push & Knead Massage" },
        { label: "Functions", value: "Massage Point Adjustment, Airbag Intensity Adjustment, Massage Intensity Adjustment, Bluetooth Connection, Roller Speed Adjustment, Automatic Detection Function" },
        { label: "Control Method", value: "Button Type" },
        { label: "Installation Method", value: "No Installation Required" },
        { label: "Color Options", value: "White" }
      ],
      imgs: [
        require("../assets/images/Massager/29.jpg"),
        require("../assets/images/Massager/29.1.jpg"),
        require("../assets/images/Massager/29.2.jpg"),
        require("../assets/images/Massager/29.3.jpg"),
        require("../assets/images/Massager/29.4.jpg"),
      ]
    },
  },
  {
    id: 'Massager030',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/30.jpg"),
    obj1: {
      title: 'Home Massage Chair Full body Home 4D Movement Space Cabin Fully Automatic Intelligent Electric Massage Chair Sofa Chair',
      money: '829.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Movement Type", value: "4D Robotic Hand Massage" },
        { label: "Heating Area", value: "Back Heating, Waist Heating" },
        { label: "Warranty Period", value: "12 Months" },
        { label: "Smart Type", value: "Body Shape Detection" },
        { label: "Smart Control", value: "Yes" },
        { label: "Applicable Parts", value: "Back, Legs, Arms, Neck, Feet, Full Body, Hips, Waist, Shoulders" },
        { label: "Chair Type", value: "Massage Chair" },
        { label: "Massage Techniques", value: "Acupressure, Tapping, Kneading, Push & Knead, Patting" },
        { label: "Guide Rail Type", value: "SL-type Guide Rail" },
        { label: "Additional Functions", value: "Bluetooth Connection, Built-in Speaker" },
        { label: "Airbag Count", value: "Airbag Quantity" },
        { label: "Functions", value: "Airbag Intensity Adjustment, Local Heat Therapy, Massage Intensity Adjustment, Bluetooth Connection, Automatic Detection Function" },
        { label: "Control Method", value: "Voice, Smart App Control, Wireless Remote Control" },
        { label: "Installation Method", value: "No Installation Required" },
        { label: "Quantity", value: "1 Piece" },
        { label: "Product Grade", value: "Brand New" },
        { label: "Color Options", value: "Coffee" }
      ],
      imgs: [
        require("../assets/images/Massager/30.jpg"),
        require("../assets/images/Massager/30.1.jpg"),
        require("../assets/images/Massager/30.2.jpg"),
        require("../assets/images/Massager/30.3.jpg"),
        require("../assets/images/Massager/30.4.jpg"),
        require("../assets/images/Massager/30.5.jpg"),
      ]
    },
  },
  {
    id: 'Massager031',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/31.jpg"),
    obj1: {
      title: 'Massage chair, home full body automatic multifunctional intelligent sofa',
      money: '966.99',
      color: ['Prussian blue'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Voltage", value: "220V" },
        { label: "Arm Massage Method", value: "U-shaped Extended & Enlarged Arm Airbags" },
        { label: "Shoulder Massage Method", value: "Double-layer Shoulder Airbag Massage" },
        { label: "Smart Control", value: "No" },
        { label: "Applicable Parts", value: "Back, Legs, Arms, Neck, Feet, Hips, Waist, Shoulders" },
        { label: "Chair Type", value: "Massage Chair" },
        { label: "Massage Techniques", value: "Tapping, Acupressure, Kneading, Stretching, Push & Knead, Patting" },
        { label: "Fabric Material", value: "Skin-friendly Water-soft Leather" },
        { label: "Additional Functions", value: "Bluetooth Connection" },
        { label: "Airbag Count", value: "31 (inclusive) - 60 (inclusive)" },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Foot Openable", value: "Yes" },
        { label: "Color Options", value: "S710 Prussian Blue, S710 After-sales Service" },
        { label: "Logistics & Installation", value: "Door-to-door Delivery, No Installation Required" },
        { label: "Movement Type", value: "3D Robotic Hand Massage" },
        { label: "Heating Area", value: "Calf Heating, Foot Heating, Hip Heating, Waist Heating" },
        { label: "Warranty Period", value: "24 Months" },
        { label: "Smart Type", value: "Body Shape Detection" },
        { label: "Guide Rail Type", value: "SL-type Guide Rail" },
        { label: "Buttock Massage Method", value: "Robotic Hand Push & Knead + Airbag Hip Clamp Massage" },
        { label: "Functions", value: "Airbag Intensity Adjustment, Local Heat Therapy, Massage Intensity Adjustment, Automatic Detection Function, Roller Speed Adjustment" },
        { label: "Control Method", value: "Wired Remote Control, Touch Screen, Button Type" },
        { label: "Installation Method", value: "No Installation Required" },
        { label: "Foot Massage Method", value: "Three-row Roller Massage" }
      ],
      imgs: [
        require("../assets/images/Massager/26.jpg"),
        require("../assets/images/Massager/26.1.jpg"),
        require("../assets/images/Massager/26.2.jpg"),
        require("../assets/images/Massager/26.3.jpg"),
        require("../assets/images/Massager/26.4.jpg"),
      ]
    },
  },
  {
    id: 'Massager032',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/32.jpg"),
    obj1: {
      title: 'Massage Chair Pro Home Full body Multi functional Massage Sofa Gift',
      money: '2000.00',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { "label": "Shoulder Massage Method", "value": "Multi-mode Combination" },
        { "label": "Chair Type", "value": "Massage Sofa" },
        { "label": "Guide Rail Type", "value": "SJ Guide Rail" },
        { "label": "Number of Airbags", "value": "30 or Less" },
        { "label": "Movement Type", "value": "4D REAL PRO 2.0 AI Smart Writing Movement" },
        { "label": "Control Method", "value": "Touch Screen" },
        { "label": "Logistics & Delivery", "value": "Door-to-door Delivery, No Installation Required" },
        { "label": "Smart Control Support", "value": "Not Supported" },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Color", value: "White" },
        { "label": "Applicable Body Parts", "value": "Back, Neck, Full Body, Hips, Shoulders" },
        { "label": "Massage Techniques", "value": "Vibration, Acupressure, Stretching, Tapping, Back Push, Kneading, Knead & Tap, Rolling, Back Press, Pounding, Percussion, Rubbing, Tuina, Knead & Knock, Patting" },
        { "label": "Additional Functions", "value": "AI Smart Detection, Music Playback, Local Heat Therapy" },
        { "label": "Functions", "value": "Massage Point Adjustment, Airbag Intensity Adjustment, Local Heat Therapy, Massage Intensity Adjustment, Bluetooth Connection, Auto Detection Function" },
        { "label": "Installation Method", "value": "No Installation Required" },
      ],
      imgs: [
        require("../assets/images/Massager/32.jpg"),
        require("../assets/images/Massager/32.1.jpg"),
        require("../assets/images/Massager/32.2.jpg"),
        require("../assets/images/Massager/32.3.png"),
      ]
    },
  },
  {
    id: 'Massager033',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/33.jpg"),
    obj1: {
      title: 'Massage chair for home use, luxurious full body, fully automatic, multifunctional space cabin sofa',
      money: '1000.00',
      color: ['Blue'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Color", value: "Blue" },
        { "label": "Movement Type", "value": "4D Robotic Hand Massage" },
        { "label": "Heating Areas", "value": "Calf Heating, Waist Heating" },
        { "label": "Warranty Period", "value": "24 Months" },
        { "label": "Smart Type", "value": "Compatible with Tmall Genie" },
        { "label": "Logistics & Installation", "value": "Door-to-door Installation" },
        { "label": "Smart Control Support", "value": "Supported" },
        { "label": "Applicable Body Parts", "value": "Full Body" },
        { "label": "Chair Type", "value": "Massage Chair" },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { "label": "Guide Rail Type", "value": "SL-type Guide Rail" },
        { "label": "Upholstery Material", "value": "Leather" },
        { "label": "Additional Functions", "value": "Bluetooth Connection, Built-in Speakers" },
        { "label": "Number of Airbags", "value": "31-60 (Inclusive)" },
        { "label": "Functions", "value": "Airbag Intensity Adjustment, Local Heat Therapy, Massage Intensity Adjustment, Auto Detection Function, Roller Speed Adjustment" },
        { "label": "Control Method", "value": "Voice Control, Smart App Control, Wired Remote Control, Button Control" },
        { "label": "Installation Method", "value": "Multi-piece Installation" },
        { "label": "Foot Massage Method", "value": "3-row Roller Massage" },
      ],
      imgs: [
        require("../assets/images/Massager/33.jpg"),
        require("../assets/images/Massager/33.1.jpg"),
        require("../assets/images/Massager/33.2.jpg"),
        require("../assets/images/Massager/33.3.jpg"),
        require("../assets/images/Massager/33.4.jpg"),
        require("../assets/images/Massager/33.5.jpg"),
      ]
    },
  },
  {
    id: 'Massager034',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/34.jpg"),
    obj1: {
      title: 'Massage chair for home use, full body multifunctional, fully automatic luxury spacecraft',
      money: '1899.95',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Voltage", value: "220V" },
        { label: "Arm Massage Method", value: "U-shaped Arm Airbag" },
        { label: "Shoulder Massage Method", value: "Mounted Shoulder Massage" },
        { label: "Smart Control", value: "Yes" },
        { label: "Applicable Parts", value: "Back, Legs, Arms, Neck, Feet, Full Body, Hips, Waist" },
        { label: "Chair Type", value: "Massage Chair" },
        { label: "Massage Techniques", value: "Tapping, Acupressure, Stretching, Kneading, Tuina, Patting" },
        { label: "Upholstery Material", value: "Leather" },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Additional Functions", value: "Automatic Body Detection, Local Heat Therapy, Roller Speed Adjustment" },
        { label: "Airbag Count", value: "31-60 (Inclusive)" },
        { label: "Foot Adjustable", value: "No" },
        { label: "Logistics & Installation", value: "Door-to-door Installation" },
        { label: "Movement Type", value: "3D Mechanical Hand Massage" },
        { label: "Heating Areas", value: "Foot Heating, Waist Heating" },
        { label: "Warranty Period", value: "36 Months" },
        { label: "Color", value: "Black" },
        { label: "Smart Type", value: "Other Smart" },
        { label: "Guide Rail Type", value: "S-shaped Rail" },
        { label: "Hip Massage Method", value: "Vibration & Airbag Hip Clamping Massage" },
        { label: "Function", value: "Local Heat Therapy" },
        { label: "Control Method", value: "Wired Remote Control, Button Type" },
        { label: "Installation Type", value: "Two-piece Easy Installation" },
        { label: "Foot Sole Massage Method", value: "Roller Massage" },
      ],
      imgs: [
        require("../assets/images/Massager/34.jpg"),
        require("../assets/images/Massager/34.1.jpg"),
        require("../assets/images/Massager/34.2.jpg"),
        require("../assets/images/Massager/34.3.jpg"),
        require("../assets/images/Massager/34.4.jpg"),
        require("../assets/images/Massager/34.5.jpg"),
      ]
    },
  },
  {
    id: 'Massager035',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/35.jpg"),
    obj1: {
      title: 'Home fully automatic intelligent electric massage chair',
      money: '888.99',
      color: ['Moon Grey Blue'],
      quantity: 1
    },
    obj2: {
      details: [

        { label: "Movement Type", value: "3D Mechanical Hand Massage" },
        { label: "Logistics & Installation", value: "Door-to-door Installation" },
        { label: "Color", value: "Moon Grey Blue" },
        { label: "Heating Areas", value: "Calf Heating, Hip Heating" },
        { label: "Warranty Period", value: "36 Months" },
        { label: "Smart Type", value: "Body Shape Detection" },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Smart Control", value: "Yes" },
        { label: "Chair Type", value: "Massage Chair" },
        { label: "Guide Rail Type", value: "SL-shaped Rail" },
        { label: "Airbag Count", value: "30 or Less" },
        { label: "Functions", value: "Massage Point Adjustment, Airbag Intensity Adjustment, Massage Intensity Adjustment, Roller Speed Adjustment" },
        { label: "Control Method", value: "Voice, Wired Remote Control, Button Type" },
        { label: "Installation Type", value: "No Installation Required" },
      ],
      imgs: [
        require("../assets/images/Massager/35.jpg"),
        require("../assets/images/Massager/35.1.jpg"),
        require("../assets/images/Massager/35.2.jpg"),
        require("../assets/images/Massager/35.3.jpg"),
        require("../assets/images/Massager/35.4.jpg"),
      ]
    },
  },
  {
    id: 'Massager036',
    type: 'Massager',
    homeImg: require("../assets/images/Massager/36.jpg"),
    obj1: {
      title: 'Massage cushion, waist massager, back massager, fully automatic kneading and kneading device',
      money: '269.95',
      color: ['Dark brown'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Color", value: "Dark brown" },
        { "label": "Massage Modes", "value": "Finger Pressure, Tapping, Kneading, Tuina" },
        { "label": "Power Supply", "value": "AC Power, Car Power" },
        { "label": "Control Type", "value": "Mechanical" },
        { "label": "Warranty Period", "value": "12 Months" },
        { label: 'Rated Voltage', value: '220V' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { "label": "Applicable Body Parts", "value": "Back, Neck, Buttocks, Waist" },
        { "label": "Airbag Count", "value": "10 or Less" },
        { "label": "Therapy Type", "value": "Tuina, Finger Pressure, Kneading" },
        { "label": "Charging Method", "value": "AC Power Supply" },
        { "label": "Product Category", "value": "Massage Cushion" },
        { "label": "Massage Head Count", "value": "5 (inclusive) - 7 (inclusive)" }
      ],
      imgs: [
        require("../assets/images/Massager/36.jpg"),
        require("../assets/images/Massager/36.1.jpg"),
        require("../assets/images/Massager/36.2.jpg"),
        require("../assets/images/Massager/36.3.jpg"),
        require("../assets/images/Massager/36.4.jpg"),
        require("../assets/images/Massager/36.5.jpg"),
        require("../assets/images/Massager/36.6.jpg"),
      ]
    },
  },
  // {
  //   id: 'Massager030',
  //   type: 'Massager',
  //   homeImg: require("../assets/images/Massager/26.jpg"),
  //   obj1: {
  //     title: 'Intelligent eye protection device for relieving eye fatigue, massage device, and hot compress',
  //     money: '69.95',
  //     color: ['White'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: "Power Supply", value: "Battery" },
  //       { label: "Massage Principle", value: "Vibration, Air pressure, Hot compress" },
  //       { label: "Foldable", value: "Yes" },
  //       { label: "Core Functions", value: "Hot compress, Vibration" },
  //       { label: "Warranty Period", value: "12 months" },
  //       { label: "Additional Functions", value: "Portable design" },
  //       { label: 'Rated Voltage', value: '220V' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: "Applicable Parts", value: "Eyes" },
  //       { label: "Applicable Symptoms", value: "Eye fatigue" },
  //       { label: "Applicable People", value: "All ages" },
  //       { label: "Color", value: "White" }
  //     ],
  //     imgs: [
  //       require("../assets/images/Massager/26.jpg"),
  //       require("../assets/images/Massager/26.1.jpg"),
  //       require("../assets/images/Massager/26.2.jpg"),
  //       require("../assets/images/Massager/26.3.jpg"),
  //       require("../assets/images/Massager/26.4.jpg"),
  //     ]
  //   },
  // },
  // {
  //   id: 'Massager030',
  //   type: 'Massager',
  //   homeImg: require("../assets/images/Massager/26.jpg"),
  //   obj1: {
  //     title: 'Intelligent eye protection device for relieving eye fatigue, massage device, and hot compress',
  //     money: '69.95',
  //     color: ['White'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: "Power Supply", value: "Battery" },
  //       { label: "Massage Principle", value: "Vibration, Air pressure, Hot compress" },
  //       { label: "Foldable", value: "Yes" },
  //       { label: "Core Functions", value: "Hot compress, Vibration" },
  //       { label: "Warranty Period", value: "12 months" },
  //       { label: "Additional Functions", value: "Portable design" },
  //       { label: 'Rated Voltage', value: '220V' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: "Applicable Parts", value: "Eyes" },
  //       { label: "Applicable Symptoms", value: "Eye fatigue" },
  //       { label: "Applicable People", value: "All ages" },
  //       { label: "Color", value: "White" }
  //     ],
  //     imgs: [
  //       require("../assets/images/Massager/26.jpg"),
  //       require("../assets/images/Massager/26.1.jpg"),
  //       require("../assets/images/Massager/26.2.jpg"),
  //       require("../assets/images/Massager/26.3.jpg"),
  //       require("../assets/images/Massager/26.4.jpg"),
  //     ]
  //   },
  // },


  {
    id: 'Beauty001',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/1.png"),
    obj1: {
      title: 'Beauty instrument for home use, facial lifting massage device, firming facial hydration introduction device, cleaning and skin rejuvenation',
      money: '32.95',
      color: ['Purple'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Efficacy', value: 'Importation & Osmosis' },
        { label: 'Vibration Function', value: 'Yes' },
        { label: 'Suitable Skin Type', value: 'All Skin Types' },
        { label: 'Power', value: '10W' },
        { label: 'Spray Water Source', value: 'Purified Water' },
        { label: 'After-sales Service', value: 'Warranty Information' },
        { label: 'Replaceable Head Type', value: 'LED Light Therapy Head' },
        { label: 'Voltage', value: '5V' },
        { label: 'Power Supply', value: 'Plug-in Power' },
        { label: 'Application Scenario', value: 'Home Use' },
        { label: 'Core Functions', value: 'Promote Absorption, Firming, Whitening' },
        { label: 'Application Area', value: 'Face' },
        { label: 'Working Principle', value: 'LED Light Therapy, Hot & Cold Compress, Massage/Vibration, Iontophoresis, Photon Rejuvenation, Microcurrent' },
        { label: 'Light Color', value: 'Blue' },
        { label: 'Color Category', value: 'Purple' }
      ],
      imgs: [
        require("../assets/images/Beauty/1.png"),
        require("../assets/images/Beauty/1.1.png"),
        require("../assets/images/Beauty/1.2.png"),
        require("../assets/images/Beauty/1.3.png"),
        require("../assets/images/Beauty/1.4.png"),
        require("../assets/images/Beauty/1.5.png"),
        require("../assets/images/Beauty/1.6.png"),
      ]
    },
  },
  {
    id: 'Beauty002',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/2.png"),
    obj1: {
      title: 'Facial care, facial lifting and firming, skin rejuvenation, face slimming device, home use face slimming and lifting device, collagen',
      money: '30.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Suitable Skin Type', value: 'All Skin Types' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Applicable Parts', value: 'face' },
        { label: 'Efficacy', value: 'Lifting & Firming' },
        { label: 'Power Supply', value: 'Plug-in Charging' },
        { label: 'Function', value: 'Other' },
        { label: 'Smart Type', value: 'Other Smart' },
        { label: 'Gear Level', value: 'More Than 5 Gears' },
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Application Scenario', value: 'Home Use' },
        { label: 'Vibration Function', value: 'No' },
        { label: 'Color Category', value: 'White' }
      ],
      imgs: [
        require("../assets/images/Beauty/2.png"),
        require("../assets/images/Beauty/2.1.png"),
        require("../assets/images/Beauty/2.2.png"),
        require("../assets/images/Beauty/2.3.png"),
        require("../assets/images/Beauty/2.4.png"),
        require("../assets/images/Beauty/2.5.png"),
        require("../assets/images/Beauty/2.6.png"),
      ]
    },
  },
  {
    id: 'Beauty003',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/3.jpg"),
    obj1: {
      title: 'New cold and hot spray machine, aromatherapy ion spray, nano hot spray beauty instrument',
      money: '69.99',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Efficacy', value: 'Hydrating' },
        { label: 'Power Supply', value: 'Plug-in Charging' },
        { label: 'Spray Type', value: 'Hot Spray' },
        { label: 'Mist Output Time', value: '30s - 90s' },
        { label: 'Smart Type', value: 'Other Smart' },
        { label: 'Suitable Skin Type', value: 'All Skin Types' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Applicable Parts', value: 'face' },
        { label: 'Application Scenario', value: 'Commercial Use' },
        { label: 'Color Category', value: 'White' }
      ],
      imgs: [
        require("../assets/images/Beauty/3.jpg"),
        require("../assets/images/Beauty/3.1.jpg"),
        require("../assets/images/Beauty/3.2.jpg"),
        require("../assets/images/Beauty/3.3.jpg"),
        require("../assets/images/Beauty/3.4.jpg"),
        require("../assets/images/Beauty/3.5.jpg"),
      ]
    },
  },
  {
    id: 'Beauty004',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/4.jpg"),
    obj1: {
      title: 'Blue light facial mask instrument acne control oil LED large array lamp bottom cover facial beauty instrument',
      money: '407.95',
      color: ['Blue'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Light Color', value: 'Blue' },
        { label: 'Efficacy', value: 'Brighten Skin Tone' },
        { label: 'Replaceable Head Type', value: 'LED Light Therapy Head' },
        { label: 'Voltage', value: '5V' },
        { label: 'Vibration Frequency Adjustability', value: 'Non-adjustable' },
        { label: 'Application Scenario', value: 'Commercial, Home, Portable, Travel' },
        { label: 'Vibration Function', value: 'No Vibration' },
        { label: 'Suitable Skin Type', value: 'All Skin Types, Dry, Oily, Combination, Normal' },
        { label: 'Body Weight', value: '350g' },
        { label: 'Core Functions', value: 'Anti-Wrinkle, Color Light, Acne Removal, Pore Minimizing, Firming' },
        { label: 'Application Area', value: 'Face' },
        { label: 'Display Type', value: 'No Display' },
        { label: 'Working Principle', value: 'LED Light Therapy, Photon Rejuvenation' },
        { label: 'Smart Type', value: 'Non-smart' },
        { label: 'Product Type', value: 'Mask Type' },
        { label: 'Body Shell Material', value: 'Silicone' },
        { label: 'Power', value: '5W' },
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Color Category', value: 'Blue' }
      ],
      imgs: [
        require("../assets/images/Beauty/4.jpg"),
        require("../assets/images/Beauty/4.1.jpg"),
        require("../assets/images/Beauty/4.2.jpg"),
        require("../assets/images/Beauty/4.3.jpg"),
        require("../assets/images/Beauty/4.4.jpg"),
        require("../assets/images/Beauty/4.5.jpg"),
        require("../assets/images/Beauty/4.6.jpg"),
      ]
    },
  },
  {
    id: 'Beauty005',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/5.jpg"),
    obj1: {
      title: 'Beauty instrument, v-face instrument, masseter muscle, double chin, facial lifting bandage, v-face beauty instrument, lifting face mask, face slimming instrument',
      money: '19.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Smart Type', value: 'Other Smart' },
        { label: 'Suitable Skin Type', value: 'All Skin Types' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Electric', value: 'Yes' },
        { label: 'Model', value: 'V-Line Beauty Device' },
        { label: 'Application Area', value: 'Face' },
        { label: 'Color Category', value: 'White' }
      ],
      imgs: [
        require("../assets/images/Beauty/5.jpg"),
        require("../assets/images/Beauty/5.1.jpg"),
        require("../assets/images/Beauty/5.2.jpg"),
        require("../assets/images/Beauty/5.3.jpg"),
        require("../assets/images/Beauty/5.4.jpg"),
        require("../assets/images/Beauty/5.5.jpg"),
        require("../assets/images/Beauty/5.6.jpg"),
      ]
    },
  },
  {
    id: 'Beauty006',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/6.jpg"),
    obj1: {
      title: 'Cold and hot beauty eye instrument micro-current eye bag swelling reduction, black eye circles, fine lines, eye massage instrument lifting and firming beauty instrument',
      money: '50.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Power Supply', value: 'Plug-in Charging' },
        { label: 'Efficacy', value: 'Firming Eye Area' },
        { label: 'Functions', value: 'Microcurrent, Hot Compress, Color Light' },
        { label: 'Gear Level', value: 'More Than 5 Gears' },
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Suitable Skin Type', value: 'All Skin Types' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Applicable Parts', value: 'eye area' },
      ],
      imgs: [
        require("../assets/images/Beauty/6.jpg"),
        require("../assets/images/Beauty/6.1.jpg"),
        require("../assets/images/Beauty/6.2.jpg"),
        require("../assets/images/Beauty/6.3.jpg"),
        require("../assets/images/Beauty/6.4.jpg"),
        require("../assets/images/Beauty/6.5.jpg"),
      ]
    },
  },
  {
    id: 'Beauty007',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/7.jpg"),
    obj1: {
      title: 'Lifting and Firming Light Wave Vibration Massage Beauty Instrument for Facial Introduction, Firming Micro-current Hot Compress Beauty Instrument',
      money: '102.99',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Suitable Skin Type', value: 'All Skin Types' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Electric', value: 'Yes' },
        { label: 'Application Area', value: 'Face' },
        { label: 'Face Slimmer Style', value: 'None' },
        { label: 'Color Category', value: 'White' }

      ],
      imgs: [
        require("../assets/images/Beauty/7.jpg"),
        require("../assets/images/Beauty/7.2.jpg"),
        require("../assets/images/Beauty/7.3.jpg"),
        require("../assets/images/Beauty/7.4.jpg"),
      ]
    },
  },
  {
    id: 'Beauty010',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/10.jpg"),
    obj1: {
      title: 'V-face beauty device recommended for home jawline gift giving',
      money: '439.99',
      color: ['Red Silver Gradient'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Packaging Type", value: "Gift Box" },
        { label: "Efficacy", value: "Lifting and Firming" },
        { label: "Vibration", value: "No" },
        { label: "Power", value: "18W" },
        { label: "After-sales Service", value: "Warranty Description" },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: "Replaceable Head Type", value: "No Replaceable Head" },
        { label: "Voltage", value: "9V" },
        { label: "Power Supply", value: "Combined Power Supply" },
        { label: "Application Scenario", value: "Home Use" },
        { label: "Warranty Period", value: "12 months" },
        { label: "Net Weight", value: "80g" },
        { label: "Core Functions", value: "Enhanced Absorption, Color Light, Microcurrent" },
        { label: "Applicable Parts", value: "Neck, Face" },
        { label: "Display Type", value: "No Display" },
        { label: "Working Principle", value: "LED + Microcurrent" },
        { label: "Light Color", value: "Red" },
        { label: "Color Options", value: "Red Silver Gradient" }

      ],
      imgs: [
        require("../assets/images/Beauty/10.jpg"),
        require("../assets/images/Beauty/10_1.jpg"),
        require("../assets/images/Beauty/10_2.jpg"),
        require("../assets/images/Beauty/10_3.jpg"),
        require("../assets/images/Beauty/10_4.jpg"),
      ]
    },
  },
  {
    id: 'Beauty011',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/11.png"),
    obj1: {
      title: 'Yellow face mask beauty device for home use, brightening, delicate repairing, gift recommendation',
      money: '500.99',
      color: ['Yellow light'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Light Color", value: "Yellow" },
        { label: "Efficacy", value: "Soothing" },
        { label: "Power Supply", value: "Battery Powered" },
        { label: "After-sales Service", value: "Warranty Period Description" },
        { label: "Voltage", value: "5V" },
        { label: "Adjustable Vibration Frequency", value: "Non-adjustable Vibration Frequency" },
        { label: "Application Scenario", value: "Home Use" },
        { label: "Vibration Function", value: "No Vibration Function" },
        { label: "Suitable Skin Type", value: "Combination Skin" },
        { label: "Product Category", value: "Light Beauty Device" },
        { label: "Core Function", value: "Color Light" },
        { label: "Applicable Parts", value: "Neck, Face" },
        { label: "Display Screen Type", value: "No Display" },
        { label: "Intelligent Type", value: "APP Control" },
        { label: "Product Type", value: "Mask Type" },
        { label: "Housing Material", value: "Silicone" },
        { label: "Power", value: "12W" },
        { label: "Packaging Type", value: "Gift Box" },
        { label: "Color Classification", value: "Yellow Light Mask" }
      ],
      imgs: [
        require("../assets/images/Beauty/11.png"),
        require("../assets/images/Beauty/11.1.jpg"),
        require("../assets/images/Beauty/11.2.jpg"),
        require("../assets/images/Beauty/11.3.jpg"),
        require("../assets/images/Beauty/11.4.jpg"),
      ]
    },
  },
  {
    id: 'Beauty012',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/12.jpg"),
    obj1: {
      title: 'Mask beauty instrument, face household large row lamp, special spectrum for theater line, facial mask, photon rejuvenation',
      money: '132.99',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Efficacy", value: "Soothing" },
        { label: "Power Supply", value: "Charger Charging" },
        { label: "Spray Water Source", value: "Herbal Extract Water" },
        { label: "After-sales Service", value: "5-Year Warranty" },
        { label: "Replaceable Head Type", value: "LED Light Therapy Head" },
        { label: "Voltage", value: "3V" },
        { label: "Application Scenario", value: "Home Use & Portable" },
        { label: "Vibration Function", value: "No Vibration Function" },
        { label: "Suitable Skin Type", value: "All Skin Types" },
        { label: "Core Function", value: "Color Light & Soothing" },
        { label: "Applicable Parts", value: "Face" },
        { label: "Display Screen Type", value: "Monochrome Screen" },
        { label: "Working Principle", value: "LED Light Therapy & Photon Rejuvenation" },
        { label: "Product Type", value: "Mask Type" },
        { label: "Housing Material", value: "Silicone" },
        { label: "Power", value: "5W" },
        { label: "Packaging Type", value: "Gift Box" },
        { label: "Color Classification", value: "Black Gold" }
      ],
      imgs: [
        require("../assets/images/Beauty/12.jpg"),
        require("../assets/images/Beauty/12.1.jpg"),
        require("../assets/images/Beauty/12.2.jpg"),
        require("../assets/images/Beauty/12.3.jpg"),
        require("../assets/images/Beauty/12.4.jpg"),
      ]
    },
  },
  {
    id: 'Beauty013',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/13.jpg"),
    obj1: {
      title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
      money: '788.99',
      color: ['black gold'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Suitable Skin Type', value: 'All Skin Types' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Color Category', value: 'black gold' },
        { label: "Efficacy", value: "Brighten Skin Tone" },
        { label: "Power Supply", value: "Plug-in Charging" },
        { label: "Vibration Function", value: "No" },
        { label: "Power", value: "36W" },
        { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
        { label: "Voltage", value: "220V" },
        { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
        { label: "Applicable Scene", value: "Home Use" },
        { label: "Core Functions", value: "Color Light, Microcurrent" },
        { label: "Applicable Parts", value: "Neck, Eyes, Face" },
        { label: "Output Frequency Range", value: "60MHz" },
        { label: "Display Type", value: "Touch Screen" },
        { label: "Working Principle", value: "Microcurrent" },
        { label: "Light Color", value: "Red, Blue" }

      ],
      imgs: [
        require("../assets/images/Beauty/13.jpg"),
        require("../assets/images/Beauty/13.1.jpg"),
        require("../assets/images/Beauty/13.2.jpg"),
        require("../assets/images/Beauty/13.3.jpg"),
        require("../assets/images/Beauty/13.4.jpg"),
      ]
    },
  },
  {
    id: 'Beauty014',
    type: 'Beauty',
    homeImg: require("../assets/images/Beauty/14.jpg"),
    obj1: {
      title: "Shaver Mi Home Men's Electric Shaver",
      money: '22.99',
      color: ['Grey'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Applicable Voltage", value: "220V" },
        { label: "Packaging Type", value: "Single Pack" },
        { label: "Shaving Method", value: "Rotary" },
        { label: "Charging Mode", value: "Wired Charging" },
        { label: "Usage Time After Full Charge", value: "60 Minutes" },
        { label: "Blade Material", value: "Stainless Steel" },
        { label: "Model", value: "S101" },
        { label: "Special Features", value: "Washable" },
        { label: "Charging Method", value: "Rechargeable" },
        { label: "Usage Type", value: "Wet & Dry Shaving" },
        { label: "Cleaning Method", value: "Full Body Washable" },
        { label: "Charging Time", value: "1.5 Hours" },
        { label: "Accessory Type", value: "None" },
        { label: "Placement Method", value: "Vertical" },
        { label: "Warranty Period", value: "24 Months" },
        { label: "Blade Count", value: "3 Blades" },
        { label: "Battery Life", value: "60 Minutes" },
        { label: "Trimmer Configuration", value: "No Trimmer" },
        { label: "Packaging Specification", value: "Basic Packaging" }

      ],
      imgs: [
        require("../assets/images/Beauty/14.jpg"),
        require("../assets/images/Beauty/14.1.jpg"),
        require("../assets/images/Beauty/14.2.jpg"),
        require("../assets/images/Beauty/14.3.jpg"),

      ]
    },
  },
  // {
  //   id: 'Beauty013',
  //   type: 'Beauty',
  //   homeImg: require("../assets/images/Beauty/13.jpg"),
  //   obj1: {
  //     title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
  //     money: '788.99',
  //     color: ['black gold'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Suitable Skin Type', value: 'All Skin Types' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Packaging Type', value: 'Basic Packaging' },
  //       { label: 'Color Category', value: 'black gold' },
  //       { label: "Efficacy", value: "Brighten Skin Tone" },
  //       { label: "Power Supply", value: "Plug-in Charging" },
  //       { label: "Vibration Function", value: "No" },
  //       { label: "Power", value: "36W" },
  //       { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
  //       { label: "Voltage", value: "220V" },
  //       { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
  //       { label: "Applicable Scene", value: "Home Use" },
  //       { label: "Core Functions", value: "Color Light, Microcurrent" },
  //       { label: "Applicable Parts", value: "Neck, Eyes, Face" },
  //       { label: "Output Frequency Range", value: "60MHz" },
  //       { label: "Display Type", value: "Touch Screen" },
  //       { label: "Working Principle", value: "Microcurrent" },
  //       { label: "Light Color", value: "Red, Blue" }

  //     ],
  //     imgs: [
  //       require("../assets/images/Beauty/13.jpg"),
  //       require("../assets/images/Beauty/13.1.jpg"),
  //       require("../assets/images/Beauty/13.2.jpg"),
  //       require("../assets/images/Beauty/13.3.jpg"),
  //       require("../assets/images/Beauty/13.4.jpg"),
  //     ]
  //   },
  // },
  // {
  //   id: 'Beauty013',
  //   type: 'Beauty',
  //   homeImg: require("../assets/images/Beauty/13.jpg"),
  //   obj1: {
  //     title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
  //     money: '788.99',
  //     color: ['black gold'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Suitable Skin Type', value: 'All Skin Types' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Packaging Type', value: 'Basic Packaging' },
  //       { label: 'Color Category', value: 'black gold' },
  //       { label: "Efficacy", value: "Brighten Skin Tone" },
  //       { label: "Power Supply", value: "Plug-in Charging" },
  //       { label: "Vibration Function", value: "No" },
  //       { label: "Power", value: "36W" },
  //       { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
  //       { label: "Voltage", value: "220V" },
  //       { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
  //       { label: "Applicable Scene", value: "Home Use" },
  //       { label: "Core Functions", value: "Color Light, Microcurrent" },
  //       { label: "Applicable Parts", value: "Neck, Eyes, Face" },
  //       { label: "Output Frequency Range", value: "60MHz" },
  //       { label: "Display Type", value: "Touch Screen" },
  //       { label: "Working Principle", value: "Microcurrent" },
  //       { label: "Light Color", value: "Red, Blue" }

  //     ],
  //     imgs: [
  //       require("../assets/images/Beauty/13.jpg"),
  //       require("../assets/images/Beauty/13.1.jpg"),
  //       require("../assets/images/Beauty/13.2.jpg"),
  //       require("../assets/images/Beauty/13.3.jpg"),
  //       require("../assets/images/Beauty/13.4.jpg"),
  //     ]
  //   },
  // },
  // {
  //   id: 'Beauty013',
  //   type: 'Beauty',
  //   homeImg: require("../assets/images/Beauty/13.jpg"),
  //   obj1: {
  //     title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
  //     money: '788.99',
  //     color: ['black gold'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Suitable Skin Type', value: 'All Skin Types' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Packaging Type', value: 'Basic Packaging' },
  //       { label: 'Color Category', value: 'black gold' },
  //       { label: "Efficacy", value: "Brighten Skin Tone" },
  //       { label: "Power Supply", value: "Plug-in Charging" },
  //       { label: "Vibration Function", value: "No" },
  //       { label: "Power", value: "36W" },
  //       { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
  //       { label: "Voltage", value: "220V" },
  //       { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
  //       { label: "Applicable Scene", value: "Home Use" },
  //       { label: "Core Functions", value: "Color Light, Microcurrent" },
  //       { label: "Applicable Parts", value: "Neck, Eyes, Face" },
  //       { label: "Output Frequency Range", value: "60MHz" },
  //       { label: "Display Type", value: "Touch Screen" },
  //       { label: "Working Principle", value: "Microcurrent" },
  //       { label: "Light Color", value: "Red, Blue" }

  //     ],
  //     imgs: [
  //       require("../assets/images/Beauty/13.jpg"),
  //       require("../assets/images/Beauty/13.1.jpg"),
  //       require("../assets/images/Beauty/13.2.jpg"),
  //       require("../assets/images/Beauty/13.3.jpg"),
  //       require("../assets/images/Beauty/13.4.jpg"),
  //     ]
  //   },
  // },
  // {
  //   id: 'Beauty013',
  //   type: 'Beauty',
  //   homeImg: require("../assets/images/Beauty/13.jpg"),
  //   obj1: {
  //     title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
  //     money: '788.99',
  //     color: ['black gold'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Suitable Skin Type', value: 'All Skin Types' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Packaging Type', value: 'Basic Packaging' },
  //       { label: 'Color Category', value: 'black gold' },
  //       { label: "Efficacy", value: "Brighten Skin Tone" },
  //       { label: "Power Supply", value: "Plug-in Charging" },
  //       { label: "Vibration Function", value: "No" },
  //       { label: "Power", value: "36W" },
  //       { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
  //       { label: "Voltage", value: "220V" },
  //       { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
  //       { label: "Applicable Scene", value: "Home Use" },
  //       { label: "Core Functions", value: "Color Light, Microcurrent" },
  //       { label: "Applicable Parts", value: "Neck, Eyes, Face" },
  //       { label: "Output Frequency Range", value: "60MHz" },
  //       { label: "Display Type", value: "Touch Screen" },
  //       { label: "Working Principle", value: "Microcurrent" },
  //       { label: "Light Color", value: "Red, Blue" }

  //     ],
  //     imgs: [
  //       require("../assets/images/Beauty/13.jpg"),
  //       require("../assets/images/Beauty/13.1.jpg"),
  //       require("../assets/images/Beauty/13.2.jpg"),
  //       require("../assets/images/Beauty/13.3.jpg"),
  //       require("../assets/images/Beauty/13.4.jpg"),
  //     ]
  //   },
  // },
  // {
  //   id: 'Beauty013',
  //   type: 'Beauty',
  //   homeImg: require("../assets/images/Beauty/13.jpg"),
  //   obj1: {
  //     title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
  //     money: '788.99',
  //     color: ['black gold'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Suitable Skin Type', value: 'All Skin Types' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Packaging Type', value: 'Basic Packaging' },
  //       { label: 'Color Category', value: 'black gold' },
  //       { label: "Efficacy", value: "Brighten Skin Tone" },
  //       { label: "Power Supply", value: "Plug-in Charging" },
  //       { label: "Vibration Function", value: "No" },
  //       { label: "Power", value: "36W" },
  //       { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
  //       { label: "Voltage", value: "220V" },
  //       { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
  //       { label: "Applicable Scene", value: "Home Use" },
  //       { label: "Core Functions", value: "Color Light, Microcurrent" },
  //       { label: "Applicable Parts", value: "Neck, Eyes, Face" },
  //       { label: "Output Frequency Range", value: "60MHz" },
  //       { label: "Display Type", value: "Touch Screen" },
  //       { label: "Working Principle", value: "Microcurrent" },
  //       { label: "Light Color", value: "Red, Blue" }

  //     ],
  //     imgs: [
  //       require("../assets/images/Beauty/13.jpg"),
  //       require("../assets/images/Beauty/13.1.jpg"),
  //       require("../assets/images/Beauty/13.2.jpg"),
  //       require("../assets/images/Beauty/13.3.jpg"),
  //       require("../assets/images/Beauty/13.4.jpg"),
  //     ]
  //   },
  // },
  // {
  //   id: 'Beauty013',
  //   type: 'Beauty',
  //   homeImg: require("../assets/images/Beauty/13.jpg"),
  //   obj1: {
  //     title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
  //     money: '788.99',
  //     color: ['black gold'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Suitable Skin Type', value: 'All Skin Types' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Packaging Type', value: 'Basic Packaging' },
  //       { label: 'Color Category', value: 'black gold' },
  //       { label: "Efficacy", value: "Brighten Skin Tone" },
  //       { label: "Power Supply", value: "Plug-in Charging" },
  //       { label: "Vibration Function", value: "No" },
  //       { label: "Power", value: "36W" },
  //       { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
  //       { label: "Voltage", value: "220V" },
  //       { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
  //       { label: "Applicable Scene", value: "Home Use" },
  //       { label: "Core Functions", value: "Color Light, Microcurrent" },
  //       { label: "Applicable Parts", value: "Neck, Eyes, Face" },
  //       { label: "Output Frequency Range", value: "60MHz" },
  //       { label: "Display Type", value: "Touch Screen" },
  //       { label: "Working Principle", value: "Microcurrent" },
  //       { label: "Light Color", value: "Red, Blue" }

  //     ],
  //     imgs: [
  //       require("../assets/images/Beauty/13.jpg"),
  //       require("../assets/images/Beauty/13.1.jpg"),
  //       require("../assets/images/Beauty/13.2.jpg"),
  //       require("../assets/images/Beauty/13.3.jpg"),
  //       require("../assets/images/Beauty/13.4.jpg"),
  //     ]
  //   },
  // },
  // {
  //   id: 'Beauty013',
  //   type: 'Beauty',
  //   homeImg: require("../assets/images/Beauty/13.jpg"),
  //   obj1: {
  //     title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
  //     money: '788.99',
  //     color: ['black gold'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Suitable Skin Type', value: 'All Skin Types' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Packaging Type', value: 'Basic Packaging' },
  //       { label: 'Color Category', value: 'black gold' },
  //       { label: "Efficacy", value: "Brighten Skin Tone" },
  //       { label: "Power Supply", value: "Plug-in Charging" },
  //       { label: "Vibration Function", value: "No" },
  //       { label: "Power", value: "36W" },
  //       { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
  //       { label: "Voltage", value: "220V" },
  //       { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
  //       { label: "Applicable Scene", value: "Home Use" },
  //       { label: "Core Functions", value: "Color Light, Microcurrent" },
  //       { label: "Applicable Parts", value: "Neck, Eyes, Face" },
  //       { label: "Output Frequency Range", value: "60MHz" },
  //       { label: "Display Type", value: "Touch Screen" },
  //       { label: "Working Principle", value: "Microcurrent" },
  //       { label: "Light Color", value: "Red, Blue" }

  //     ],
  //     imgs: [
  //       require("../assets/images/Beauty/13.jpg"),
  //       require("../assets/images/Beauty/13.1.jpg"),
  //       require("../assets/images/Beauty/13.2.jpg"),
  //       require("../assets/images/Beauty/13.3.jpg"),
  //       require("../assets/images/Beauty/13.4.jpg"),
  //     ]
  //   },
  // },
  // {
  //   id: 'Beauty013',
  //   type: 'Beauty',
  //   homeImg: require("../assets/images/Beauty/13.jpg"),
  //   obj1: {
  //     title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
  //     money: '788.99',
  //     color: ['black gold'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Suitable Skin Type', value: 'All Skin Types' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Packaging Type', value: 'Basic Packaging' },
  //       { label: 'Color Category', value: 'black gold' },
  //       { label: "Efficacy", value: "Brighten Skin Tone" },
  //       { label: "Power Supply", value: "Plug-in Charging" },
  //       { label: "Vibration Function", value: "No" },
  //       { label: "Power", value: "36W" },
  //       { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
  //       { label: "Voltage", value: "220V" },
  //       { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
  //       { label: "Applicable Scene", value: "Home Use" },
  //       { label: "Core Functions", value: "Color Light, Microcurrent" },
  //       { label: "Applicable Parts", value: "Neck, Eyes, Face" },
  //       { label: "Output Frequency Range", value: "60MHz" },
  //       { label: "Display Type", value: "Touch Screen" },
  //       { label: "Working Principle", value: "Microcurrent" },
  //       { label: "Light Color", value: "Red, Blue" }

  //     ],
  //     imgs: [
  //       require("../assets/images/Beauty/13.jpg"),
  //       require("../assets/images/Beauty/13.1.jpg"),
  //       require("../assets/images/Beauty/13.2.jpg"),
  //       require("../assets/images/Beauty/13.3.jpg"),
  //       require("../assets/images/Beauty/13.4.jpg"),
  //     ]
  //   },
  // },
  // {
  //   id: 'Beauty013',
  //   type: 'Beauty',
  //   homeImg: require("../assets/images/Beauty/13.jpg"),
  //   obj1: {
  //     title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
  //     money: '788.99',
  //     color: ['black gold'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Suitable Skin Type', value: 'All Skin Types' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Packaging Type', value: 'Basic Packaging' },
  //       { label: 'Color Category', value: 'black gold' },
  //       { label: "Efficacy", value: "Brighten Skin Tone" },
  //       { label: "Power Supply", value: "Plug-in Charging" },
  //       { label: "Vibration Function", value: "No" },
  //       { label: "Power", value: "36W" },
  //       { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
  //       { label: "Voltage", value: "220V" },
  //       { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
  //       { label: "Applicable Scene", value: "Home Use" },
  //       { label: "Core Functions", value: "Color Light, Microcurrent" },
  //       { label: "Applicable Parts", value: "Neck, Eyes, Face" },
  //       { label: "Output Frequency Range", value: "60MHz" },
  //       { label: "Display Type", value: "Touch Screen" },
  //       { label: "Working Principle", value: "Microcurrent" },
  //       { label: "Light Color", value: "Red, Blue" }

  //     ],
  //     imgs: [
  //       require("../assets/images/Beauty/13.jpg"),
  //       require("../assets/images/Beauty/13.1.jpg"),
  //       require("../assets/images/Beauty/13.2.jpg"),
  //       require("../assets/images/Beauty/13.3.jpg"),
  //       require("../assets/images/Beauty/13.4.jpg"),
  //     ]
  //   },
  // },
  // {
  //   id: 'Beauty013',
  //   type: 'Beauty',
  //   homeImg: require("../assets/images/Beauty/13.jpg"),
  //   obj1: {
  //     title: 'Household facial red and blue light massage device, specialized facial beauty equipment',
  //     money: '788.99',
  //     color: ['black gold'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Suitable Skin Type', value: 'All Skin Types' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },
  //       { label: 'Packaging Type', value: 'Basic Packaging' },
  //       { label: 'Color Category', value: 'black gold' },
  //       { label: "Efficacy", value: "Brighten Skin Tone" },
  //       { label: "Power Supply", value: "Plug-in Charging" },
  //       { label: "Vibration Function", value: "No" },
  //       { label: "Power", value: "36W" },
  //       { label: "After-sales Service", value: "Warranty Description, Extended Warranty" },
  //       { label: "Voltage", value: "220V" },
  //       { label: "Adjustable", value: "Vibration Frequency Not Adjustable" },
  //       { label: "Applicable Scene", value: "Home Use" },
  //       { label: "Core Functions", value: "Color Light, Microcurrent" },
  //       { label: "Applicable Parts", value: "Neck, Eyes, Face" },
  //       { label: "Output Frequency Range", value: "60MHz" },
  //       { label: "Display Type", value: "Touch Screen" },
  //       { label: "Working Principle", value: "Microcurrent" },
  //       { label: "Light Color", value: "Red, Blue" }

  //     ],
  //     imgs: [
  //       require("../assets/images/Beauty/13.jpg"),
  //       require("../assets/images/Beauty/13.1.jpg"),
  //       require("../assets/images/Beauty/13.2.jpg"),
  //       require("../assets/images/Beauty/13.3.jpg"),
  //       require("../assets/images/Beauty/13.4.jpg"),
  //     ]
  //   },
  // },



  {
    id: 'Home001',
    type: 'Home',
    homeImg: require("../assets/images/Home/1.jpg"),
    obj1: {
      title: 'Jet electric toothbrush for adults, 2026 new model, bubble soft bristles, suitable for both men and women, automatic sonic wave',
      money: '30.95',
      color: ['dark gray'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Applicable Parts', value: 'oral cavity' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Additional Function', value: 'Gum Care' },
        { label: 'Warranty Period', value: '12 Months' },
        { label: 'Electric Toothbrush Type', value: 'Air Jet Type' },
        { label: 'Charging Mode', value: 'Magnetic Charging' },
        { label: 'Model', value: 'PH5 Air Jet Electric Toothbrush' },
        { label: 'Battery Life', value: '1 Month' },
        { label: 'Number of Working Modes', value: '4' },
        { label: 'Bristle Material', value: 'DuPont Soft Bristles' },
        { label: 'Brush Head Type', value: 'Sensitive Brush Head' },
        { label: 'Style', value: 'Air Jet Type' },
        { label: 'Target User', value: 'Universal' },
        { label: 'Included Brush Heads', value: '3' },
        { label: 'Packaging Type', value: 'Gift Box' },
        { label: 'Waterproof Rating', value: 'IPX7' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Color Category', value: 'dark gray' }
      ],
      imgs: [
        require("../assets/images/Home/1.jpg"),
        require("../assets/images/Home/1.1.jpg"),
        require("../assets/images/Home/1.2.jpg"),
        require("../assets/images/Home/1.3.jpg"),
        require("../assets/images/Home/1.4.jpg"),
        require("../assets/images/Home/1.5.jpg"),
        require("../assets/images/Home/1.6.jpg"),
        require("../assets/images/Home/1.7.jpg"),
      ]
    },
  },
  {
    id: 'Home002',
    type: 'Home',
    homeImg: require("../assets/images/Home/2.jpg"),
    obj1: {
      title: 'Ultrasonic toothbrush, dental cleaner, household cleaning electric water floss',
      money: '165.95',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Applicable Parts', value: 'oral cavity' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Standard Cleaning Method', value: 'Ultrasonic' },
        { label: 'Function', value: 'Deep Cleaning' },
        { label: 'Warranty Period', value: '2 Years' },
        { label: 'Application Scenario', value: 'Family' },
        { label: 'Packaging Type', value: 'Gift Box' },
        { label: 'Working Mode', value: 'Ultrasonic Mode' },
        { label: 'Color Category', value: 'Black' },
        { label: 'Quantity', value: '1 Piece' },
      ],
      imgs: [
        require("../assets/images/Home/2.jpg"),
        require("../assets/images/Home/2.1.jpg"),
        require("../assets/images/Home/2.2.jpg"),
        require("../assets/images/Home/2.3.jpg"),
      ]
    },
  },
  {
    id: 'Home008',
    type: 'Home',
    homeImg: require("../assets/images/Home/8.jpg"),
    obj1: {
      title: 'Flushing device, household dental cleaner, toothbrush, water flossing device, electric ultrasonic orthodontic device, portable oral care device',
      money: '59.98',
      color: ['green waves of wheat'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'green waves of wheat' },
        { label: 'Charging Method', value: 'Type-C' },
        { label: 'Feature', value: 'Portable' },
        { label: 'Application Area', value: 'Oral Cavity' },
        { label: 'Warranty Period', value: '12 Months' },
        { label: 'Nozzle Type', value: 'Standard Nozzle' },
        { label: 'Application Scenario', value: 'Travel' },
        { label: 'Working Mode', value: 'Pulse Type' },
        { label: 'Waterproof Rating', value: 'IPX7' },
        { label: 'Standard Cleaning Method', value: 'High Pressure Pulse' },
        { label: 'Function', value: 'Deep Cleaning' },
        { label: 'Suitable For', value: 'Universal' },
        { label: 'Water Tank Capacity', value: '140ml' },
        { label: 'Packaging Type', value: 'Gift Box' },
        { label: 'Single Battery Life', value: '100 Days' }
      ],
      imgs: [
        require("../assets/images/Home/8.jpg"),
        require("../assets/images/Home/8.1.jpg"),
        require("../assets/images/Home/8.2.jpg"),
        require("../assets/images/Home/8.3.jpg"),
        require("../assets/images/Home/8.4.jpg"),
        require("../assets/images/Home/8.6.jpg"),
      ]
    },
  },
  {
    id: 'Home009',
    type: 'Home',
    homeImg: require("../assets/images/Beauty/8.jpg"),
    obj1: {
      title: 'Ultrasonic toothbrush, visible household dental calculus remover, tooth cleaning miracle tool, tooth stain spray, portable',
      money: '249.99',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Applicable Population', value: 'General' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Electric', value: 'Yes' },
        { label: 'Application Area', value: 'oral cavity' },
        { label: 'Color Category', value: 'White' },
        { label: 'Applicable scenarios', value: 'household use' },
      ],
      imgs: [
        require("../assets/images/Beauty/8.jpg"),
        require("../assets/images/Beauty/8.1.jpg"),
        require("../assets/images/Beauty/8.2.jpg"),
        require("../assets/images/Beauty/8.3.jpg"),
        require("../assets/images/Beauty/8.4.jpg"),
        require("../assets/images/Beauty/8.5.jpg"),
        require("../assets/images/Beauty/8.6.jpg"),
      ]
    },
  },
  {
    id: 'Home010',
    type: 'Home',
    homeImg: require("../assets/images/Beauty/9.jpg"),
    obj1: {
      title: 'Dental scaler, ultrasonic toothbrush, household water flosser, portable dental cleaner, orthodontic electric toothbrush, for removing dental plaque',
      money: '89.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Packaging Type', value: 'Basic Packaging' },
        { label: 'Electric', value: 'Yes' },
        { label: 'Application Area', value: 'oral cavity' },
        { label: 'Color Category', value: 'White' },
        { label: 'Function', value: 'Oral sterilization' },
        { label: 'warranty period', value: '3 years' },
      ],
      imgs: [
        require("../assets/images/Beauty/9.jpg"),
        require("../assets/images/Beauty/9.1.jpg"),
        require("../assets/images/Beauty/9.2.jpg"),
        require("../assets/images/Beauty/9.3.jpg"),
        require("../assets/images/Beauty/9.4.jpg"),
        require("../assets/images/Beauty/9.5.jpg"),
      ]
    },
  },
  {
    id: 'Home003',
    type: 'Home',
    homeImg: require("../assets/images/Home/3.jpg"),
    obj1: {
      title: 'Smart electric towel rack, bathroom rotating carbon fiber heated towel rack',
      money: '100.95',
      color: ['Grey'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Application Scenario', value: 'Family' },
        { label: 'Color', value: 'Grey' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Layers', value: '4 Layers' },
        { label: 'Length', value: '60cm' },
        { label: 'Material', value: '201 Stainless Steel' },
        { label: 'Installation Method', value: 'Wall-mounted' },
        { label: 'Surface Craft', value: 'Electrostatic Spraying' },
      ],
      imgs: [
        require("../assets/images/Home/3.jpg"),
        require("../assets/images/Home/3.1.jpg"),
        require("../assets/images/Home/3.2.jpg"),
        require("../assets/images/Home/3.3.jpg"),
        require("../assets/images/Home/3.5.jpg"),
        require("../assets/images/Home/3.6.jpg"),
      ]
    },
  },
  {
    id: 'Home004',
    type: 'Home',
    homeImg: require("../assets/images/Home/4.png"),
    obj1: {
      title: 'Electrically heated and thermostatically controlled household carbon fiber towel rack with all-copper minimalist design, intelligent drying and sterilization function',
      money: '427.95',
      color: ['Silvery'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Application Scenario', value: 'Family' },
        { label: 'Color', value: 'Silvery' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Layers', value: '5 Layers' },
        { label: 'Length', value: '70cm' },
        { label: 'Material', value: 'Copper' },
        { label: 'Installation Method', value: 'Drill-mounted' },
        { label: 'Surface Craft', value: 'Brushed' },
      ],
      imgs: [
        require("../assets/images/Home/4.png"),
        require("../assets/images/Home/4.1.png"),
        require("../assets/images/Home/4.2.png"),
        require("../assets/images/Home/4.3.png"),
        require("../assets/images/Home/4.4.png"),
        require("../assets/images/Home/4.5.png"),
      ]
    },
  },
  {
    id: 'Home005',
    type: 'Home',
    homeImg: require("../assets/images/Home/5.png"),
    obj1: {
      title: 'Electric towel rack, concealed installation, carbon fiber heating, drying, storage, shelf for bath towels, vertical rod, copper',
      money: '227.95',
      color: ['Gold'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Length', value: '80cm' },
        { label: 'Material', value: 'Copper' },
        { label: 'Installation Method', value: 'Drill-mounted' },
        { label: 'Color Category', value: 'Gold' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Application Scenario', value: 'Family' },
        { label: 'Quantity', value: '1 Piece' },
      ],
      imgs: [
        require("../assets/images/Home/5.png"),
        require("../assets/images/Home/5.1.png"),
        require("../assets/images/Home/5.2.png"),
        require("../assets/images/Home/5.3.png"),
      ]
    },
  },
  {
    id: 'Home006',
    type: 'Home',
    homeImg: require("../assets/images/Home/6.png"),
    obj1: {
      title: 'Smart integrated toilet with automatic opening and closing lid, flushing, sterilization, and pedestal pan',
      money: '989.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Additional Function', value: 'Electrolyzed Water Sterilization' },
        { label: 'Water Efficiency Grade', value: 'Level 2' },
        { label: 'Remote Control Included', value: 'Yes' },
        { label: 'Min Rough-in', value: 'Other' },
        { label: 'Safety Protection', value: 'IPX4 Waterproof' },
        { label: 'Design Style', value: 'Modern' },
        { label: 'Height', value: '546mm' },
        { label: 'Soft Close Seat', value: 'Yes' },
        { label: 'Flushing Type', value: 'Jet Siphon' },
        { label: 'Water Heating', value: 'Instant Heating' },
        { label: 'Width', value: '386mm' },
        { label: 'Main Material', value: 'Ceramic' },
        { label: 'Water Temp Control', value: 'Remote Control Button' },
        { label: 'Drainage Direction', value: 'Floor Drain' },
        { label: 'Sterilization Method', value: 'Electrolyzed Water Sterilization' },
        { label: 'Color Category', value: 'White' },
        { label: 'Installation Method', value: 'Floor-mounted' },
        { label: 'Light Function', value: 'No Night Light' },
        { label: 'Seat Material', value: 'PP' },
        { label: 'Waterproof Rating', value: 'IPX4' },
        { label: 'Suitable For', value: 'Adults Universal' },
        { label: 'Nozzle Material', value: 'Resin' },
        { label: 'Length', value: '722mm' },
        { label: 'Water Pressure', value: '0.05-0.75MPa' },
        { label: 'Nozzle Self-cleaning', value: 'Supported' }
      ],
      imgs: [
        require("../assets/images/Home/6.png"),
        require("../assets/images/Home/6.1.png"),
        require("../assets/images/Home/6.2.png"),
        require("../assets/images/Home/6.3.png"),
        require("../assets/images/Home/6.4.png"),
        require("../assets/images/Home/6.5.png"),
        require("../assets/images/Home/6.6.png"),
      ]
    },
  },
  {
    id: 'Home007',
    type: 'Home',
    homeImg: require("../assets/images/Home/7.png"),
    obj1: {
      title: 'Smart toilet seat with automatic drying and deodorizing function, household automatic opening cover plate, full-function flush device',
      money: '349.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Additional Function', value: 'Instant Heating Type' },
        { label: 'Waterproof Rating', value: 'IPX4' },
        { label: 'Width', value: '400mm' },
        { label: 'Light Function', value: 'Yes' },
        { label: 'Length', value: '517mm' },
        { label: 'Energy Efficiency Grade', value: 'Level 2' },
        { label: 'Safety Protection', value: 'IPX4 Waterproof' },
        { label: 'Material', value: 'PP Board' },
        { label: 'Water Heating Type', value: 'Instant Heating' },
        { label: 'Seat Heating Method', value: 'Instant Heating' },
        { label: 'Shape', value: 'U-type' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Seat Material', value: 'Antibacterial Material' },
        { label: 'Color Category', value: 'White' }
      ],
      imgs: [
        require("../assets/images/Home/7.png"),
        require("../assets/images/Home/7.1.png"),
        require("../assets/images/Home/7.2.png"),
        require("../assets/images/Home/7.3.png"),
        require("../assets/images/Home/7.4.png"),
        require("../assets/images/Home/7.5.png"),
      ]
    },
  },
  {
    id: 'Home00',
    type: 'Home',
    homeImg: require("../assets/images/Home/9.jpg"),
    obj1: {
      title: 'Electric towel rack for household use',
      money: '150.95',
      color: ['Grey'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Length", value: "80cm" },
        { label: "Material", value: "Copper" },
        { label: "Installation Method", value: "Wall-mounted" },
        { label: "Surface Process", value: "Brushed" },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Seat Material', value: 'Antibacterial Material' },
        { label: 'Color Category', value: 'Grey' }
      ],
      imgs: [
        require("../assets/images/Home/9.jpg"),
        require("../assets/images/Home/9.1.jpg"),
        require("../assets/images/Home/9.2.jpg"),
        require("../assets/images/Home/9.3.jpg"),
      ]
    },
  },
  {
    id: 'Home010',
    type: 'Home',
    homeImg: require("../assets/images/Home/10.jpg"),
    obj1: {
      title: 'Electric towel rack for household use',
      money: '102.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Length", value: "50cm" },
        { label: "Material", value: "Space Aluminum" },
        { label: "Installation Method", value: "Wall-mounted" },
        { label: "Surface Process", value: "Brushed" },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Seat Material', value: 'Antibacterial Material' },
        { label: 'Color Category', value: 'White' }
      ],
      imgs: [
        require("../assets/images/Home/10.jpg"),
        require("../assets/images/Home/10.1.jpg"),
        require("../assets/images/Home/10.2.jpg"),
        require("../assets/images/Home/10.3.jpg"),
      ]
    },
  },
  {
    id: 'Home0011',
    type: 'Home',
    homeImg: require("../assets/images/Home/11.jpg"),
    obj1: {
      title: 'Intelligent electric towel rack for heating, drying, and disinfection',
      money: '88.95',
      color: ['Grey'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Length", value: "70cm" },
        { label: "Material", value: "Space Aluminum" },
        { label: "Installation Method", value: "Wall-mounted" },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Surface Process", value: "piano lacquer finish" },
        { label: 'Seat Material', value: 'Antibacterial Material' },
        { label: 'Color Category', value: 'Grey' }
      ],
      imgs: [
        require("../assets/images/Home/11.jpg"),
        require("../assets/images/Home/11.1.jpg"),
        require("../assets/images/Home/11.2.jpg"),
        require("../assets/images/Home/11.3.jpg"),
        require("../assets/images/Home/11.4.jpg"),
      ]
    },
  },
  {
    id: 'Home012',
    type: 'Home',
    homeImg: require("../assets/images/Home/12.jpg"),
    obj1: {
      title: 'Villa Hotel Double Couple Independent Surfing Bath',
      money: '999.99',
      color: ['Bronze Brown'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "With Armrest", value: "Yes" },
        { label: "Additional Functions", value: "Constant Temperature Heating, Surf Massage, RGB Lights..." },
        { label: "Material", value: "Acrylic" },
        { label: "Style", value: "Freestanding" },
        { label: "Faucet Included", value: "Included" },
        { label: "Local Service", value: "Same-city Door-to-door Delivery" },
        { label: "Model", value: "GW-8059" },
        { label: "Length", value: "≈1.8M" },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Color Category', value: 'Bronze Brown' }
      ],
      imgs: [
        require("../assets/images/Home/12.jpg"),
        require("../assets/images/Home/12.1.jpg"),
        require("../assets/images/Home/12.2.jpg"),
        require("../assets/images/Home/12.3.jpg"),
        require("../assets/images/Home/12.4.jpg"),
      ]
    },
  },
  {
    id: 'Home0013',
    type: 'Home',
    homeImg: require("../assets/images/Home/13.jpg"),
    obj1: {
      title: 'Household hydrogen rich water machine, strontium rich mineralized water purifier',
      money: '620.95',
      color: ['Gray'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Heating Method", value: "Instant Heating" },
        { label: "Installation Method", value: "Countertop" },
        { label: "Tank Capacity", value: "5.4L" },
        { label: "Working Principle", value: "PEM Electrolytic Hydrogen Production / Reverse Osmosis" },
        { label: "With Purification Function", value: "Supports Purification Function" },
        { label: "Voltage", value: "220V" },
        { label: "Rated Water Output", value: "24L/h" },
        { label: "Water Efficiency Grade", value: "Grade 1" },
        { label: "Body Height", value: "40cm" },
        { label: "Body Width", value: "43cm" },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Color Category', value: 'Gray' }
      ],
      imgs: [
        require("../assets/images/Home/13.jpg"),
        require("../assets/images/Home/13.1.jpg"),
        require("../assets/images/Home/13.2.jpg"),
        require("../assets/images/Home/13.3.jpg"),
        require("../assets/images/Home/13.4.jpg"),
        require("../assets/images/Home/13.5.jpg"),
        require("../assets/images/Home/13.6.jpg"),
      ]
    },
  },
  {
    id: 'Home0014',
    type: 'Home',
    homeImg: require("../assets/images/Home/14.jpg"),
    obj1: {
      title: 'Crystal diamond square intelligent toilet K3 with no water pressure limit, silent flushing, built-in water filter core',
      money: '499.99',
      color: ['Gray'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Additional Functions", value: "Quiet Flush System" },
        { label: "Water Efficiency Grade", value: "Grade 2" },
        { label: "Remote Control Included", value: "Yes" },
        { label: "Minimum Rough-in", value: "400mm 300mm 350mm 250mm" },
        { label: "Safety Protection", value: "IPX4 Waterproof Protection" },
        { label: "Design Style", value: "Modern Style" },
        { label: "Height", value: "465mm" },
        { label: "Soft-close Seat Cover", value: "Yes" },
        { label: "Toilet Drainage Type", value: "Tornado Flush" },
        { label: "Load Capacity", value: "400kg" },
        { label: "Flush Water Heating", value: "Instant Heating" },
        { label: "Width", value: "405mm" },
        { label: "Main Material", value: "Ceramic" },
        { label: "Installation Service", value: "Installation Service Available" },
        { label: "Flush Water Temperature Adjustment", value: "Remote Control Button Adjustment" },
        { label: "Drying Wind Speed Levels", value: "3" },
        { label: "Drainage Direction", value: "Floor Drain" },
        { label: "Smart Type", value: "Other Smart Features" },
        { label: "Installation Method", value: "Floor-mounted" },
        { label: "Light Function", value: "Night Light Supported" },
        { label: "Water Tank Capacity", value: "5L" },
        { label: "Lid Flip Sensor", value: "Capacitive Foot Sensor" },
        { label: "Seat Temperature Adjustment", value: "Remote Control Button Adjustment" },
        { label: "Warranty Period", value: "3 Years" },
        { label: "Deodorization Function", value: "Aromatherapy Deodorization" },
        { label: "Seat Cover Material", value: "ABS" },
        { label: "Waterproof Rating", value: "IPX4" },
        { label: "Applicable Users", value: "For Adults" },
        { label: "Flush Button Type", value: "Side Button" },
        { label: "Load Range", value: "400kg" },
        { label: "Length", value: "715mm" },
        { label: "Water Pressure Requirement", value: "0.15-0.75MPa" },
        { label: "Warm Air Drying Adjustment", value: "Remote Control Button Adjustment" },
        { label: "Nozzle Self-cleaning", value: "Nozzle Self-cleaning Supported" },
        { label: 'Quantity', value: '1 Piece' },
        { label: 'Color Category', value: 'Gray' }
      ],
      imgs: [
        require("../assets/images/Home/14.jpg"),
        require("../assets/images/Home/14.1.jpg"),
        require("../assets/images/Home/14.2.jpg"),
        require("../assets/images/Home/14.3.jpg"),
        require("../assets/images/Home/14.4.jpg"),
      ]
    },
  },
  {
    id: 'Home0015',
    type: 'Home',
    homeImg: require("../assets/images/Home/15.jpg"),
    obj1: {
      title: 'Intelligent Electric Towel Rack with Carbon Fiber Heating, Drying and Timing Function',
      money: '129.99',
      color: ['Grey'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Color Category', value: 'Grey' },
        { label: "Length", value: "50cm" },
        { label: "Material", value: "mild steel" },
        { label: 'Quantity', value: '1 Piece' },
        { "label": "Installation Method", "value": "Drill-mounted Type" },
        { label: 'Seat Material', value: 'Antibacterial Material' },
      ],
      imgs: [
        require("../assets/images/Home/15.jpg"),
        require("../assets/images/Home/15.1.jpg"),
        require("../assets/images/Home/15.2.jpg"),
        require("../assets/images/Home/15.3.jpg"),
        require("../assets/images/Home/15.4.jpg"),
      ]
    },
  },
  {
    id: 'Home0016',
    type: 'Home',
    homeImg: require("../assets/images/Home/16.jpg"),
    obj1: {
      title: 'Single Cloud Control Home Independent Bathtub, Bathing, Thermostatic Massage, Intelligent Bathtub',
      money: '638.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'White' },
        { "label": "With Armrests", "value": "No" },
        { "label": "Material", "value": "Acrylic" },
        { "label": "Faucet Included", "value": "Not Included" },
        { "label": "Style", "value": "Freestanding" },
        { "label": "Installation Method", "value": "Freestanding" },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { "label": "Warranty Period", "value": "3 Years" },
        { "label": "Capacity", "value": "159L" },
        { "label": "Local Delivery Service", "value": "Local Logistics Door-to-door Delivery" },
        { "label": "Drainage Method", "value": "Pop-up Drain" },
        { "label": "On-site Measurement", "value": "Not Provided" },
        { "label": "Additional Functions", "value": "Constant Temperature, APP Interconnection, Intelligent Temperature Control, Whirlpool Massage, Waterproof Audio & Video, Anti-slip Bottom" },
        { "label": "Length", "value": "1.5m, 1.7m" },
        { "label": "Shape", "value": "Oval Bathtub" },
        { "label": "Width", "value": "780mm" },
        { "label": "On-site Installation", "value": "Provided" },
        { "label": "Old Tub Removal", "value": "Not Provided" },
        { "label": "Height", "value": "400mm" },
      ],
      imgs: [
        require("../assets/images/Home/16.jpg"),
        require("../assets/images/Home/16.1.jpg"),
        require("../assets/images/Home/16.2.jpg"),
        require("../assets/images/Home/16.3.jpg"),
        require("../assets/images/Home/16.4.jpg"),
        require("../assets/images/Home/16.5.jpg"),
      ]
    },
  },
  {
    id: 'Home017',
    type: 'Home',
    homeImg: require("../assets/images/Home/17.jpg"),
    obj1: {
      title: 'Internet celebrity hotels, homestays, surfing massage bathtubs',
      money: '399.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'White' },
        { "label": "Additional Functions", "value": "Constant Temperature Heating, RGB Ambient Lighting, Smart Control Panel" },
        { "label": "Material", "value": "Acrylic" },
        { "label": "Style", "value": "Freestanding" },
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { "label": "With Armrests", "value": "Yes" },
        { "label": "Faucet Included", "value": "Included" },
        { "label": "Local Delivery Service", "value": "Local Logistics Door-to-door Delivery" },
        { "label": "Capacity", "value": "260L" },
        { "label": "Model", "value": "8038" },
        { "label": "Length", "value": "≈1.6M, ≈1.5M, ≈1.7M" },
      ],
      imgs: [
        require("../assets/images/Home/17.jpg"),
        require("../assets/images/Home/17.1.jpg"),
        require("../assets/images/Home/17.2.jpg"),
        require("../assets/images/Home/17.3.jpg"),
        require("../assets/images/Home/17.4.jpg"),
      ]
    },
  },
  {
    id: 'Home0018',
    type: 'Home',
    homeImg: require("../assets/images/Home/18.jpg"),
    obj1: {
      title: 'Home constant temperature heated surfing massage cylinder',
      money: '488.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { "label": "With Armrests", "value": "No" },
        { "label": "Additional Functions", "value": "Smart Panel Control" },
        { "label": "Material", "value": "Acrylic" },
        { "label": "Style", "value": "Freestanding" },
        { "label": "Faucet Included", "value": "Included" },
        { "label": "Local Delivery Service", "value": "Local Logistics Door-to-door Delivery" },
        { "label": "Capacity", "value": "Single Person" },
        { "label": "Model", "value": "5048" },
        { "label": "Length", "value": "≈1.6M, ≈1.8M, ≈1.7M" },
        { label: 'Color Category', value: 'White' },
      ],
      imgs: [
        require("../assets/images/Home/18.jpg"),
        require("../assets/images/Home/18.1.jpg"),
        require("../assets/images/Home/18.2.jpg"),
        require("../assets/images/Home/18.3.jpg"),
        require("../assets/images/Home/18.4.jpg"),
      ]
    },
  },
  {
    id: 'Home0019',
    type: 'Home',
    homeImg: require("../assets/images/Home/19.jpg"),
    obj1: {
      title: 'Outdoor villa SPA massage bathtub hot spring large bathtub constant temperature bubble surfing spa pool',
      money: '1499.99',
      color: ['Brown'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { "label": "Additional Functions", "value": "Bubble Massage, Constant Temperature Heating, Temperature Display, RGB Ambient Lighting" },
        { "label": "Material", "value": "Acrylic" },
        { "label": "Style", "value": "Freestanding" },
        { "label": "Capacity", "value": "6 Person" },
        { "label": "Faucet Included", "value": "Included" },
        { "label": "Local Delivery Service", "value": "Local Logistics Door-to-door Delivery" },
        { label: 'Color Category', value: 'Brown' },
        { "label": "Faucet Included", "value": "Included" }
      ],
      imgs: [
        require("../assets/images/Home/19.jpg"),
        require("../assets/images/Home/19.1.jpg"),
        require("../assets/images/Home/19.3.jpg"),
        require("../assets/images/Home/19.4.png"),
        require("../assets/images/Home/19.5.png"),
      ]
    },
  },
  {
    id: 'Home0020',
    type: 'Home',
    homeImg: require("../assets/images/Home/20.jpg"),
    obj1: {
      title: 'Smart toilet with no water pressure limit, integrated household toilet with built-in aromatherapy',
      money: '209.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: "Additional Functions", value: "Night Light" },
        { label: "Water Efficiency Level", value: "Level 2" },
        { label: "Remote Control", value: "Included" },
        { label: "Minimal Rough-in", value: "400mm 300mm 350mm 250mm" },
        { label: "Local Service", value: "Delivery & Installation" },
        { label: "Safety Protection", value: "IPX4 Waterproof" },
        { label: "Single Flush Volume", value: "1L" },
        { label: "Design Style", value: "Cream Style" },
        { label: "Height", value: "422mm" },
        { label: "Soft Closing Lid", value: "Yes" },
        { label: "Flushing Method", value: "Siphon + Power Assist" },
        { label: "Load Capacity", value: "Above 100KG-150KG" },
        { label: "Width", value: "425mm" },
        { label: "Main Material", value: "Plastic" },
        { label: "Installation Service", value: "Installation Supported" },
        { label: "Drying Fan Speed", value: "4 Gears" },
        { label: "Drainage Type", value: "Floor Drain" },
        { label: "Sterilization Method", value: "UV Sterilization" },
        { label: "Model", value: "166" },
        { label: "Smart Type", value: "Other Smart" },
        { label: "Installation Type", value: "Floor Mounted" },
        { label: "Lighting Function", value: "Night Lighting Supported" },
        { label: "Seat Material", value: "ABS" },
        { label: "Warranty Period", value: "3 Years" },
        { label: "Lid Material", value: "Plastic" },
        { label: "Waterproof Rating", value: "IPX4" },
        { label: "Suitable For", value: "Adults" },
        { label: "Max Load", value: "400kg" },
        { label: "Length", value: "600mm" },
        { label: "Water Pressure", value: "0-1MPa" },
        { label: 'Color Category', value: 'White' }
      ],
      imgs: [
        require("../assets/images/Home/20.jpg"),
        require("../assets/images/Home/20.1.jpg"),
        require("../assets/images/Home/20.2.jpg"),
        require("../assets/images/Home/20.3.jpg"),
        require("../assets/images/Home/20.4.jpg"),
      ]
    },
  },
  {
    id: 'Home0021',
    type: 'Home',
    homeImg: require("../assets/images/Home/21.jpg"),
    obj1: {
      title: 'Retro intelligent toilet, light luxury, fully automatic integrated household electric intelligent sensing flip toilet',
      money: '400.95',
      color: ['Flaxen gray'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'Flaxen gray' },
        { label: "Additional Functions", value: "Mobile Control" },
        { label: "Water Efficiency Level", value: "Level 1" },
        { label: "Remote Control Included", value: "Yes" },
        { label: "Minimal Rough-in", value: "Other 400mm 305mm 350mm" },
        { label: "Safety Protection", value: "IPX4 Waterproof, Overheat Protection, Leakage Protection" },
        { label: "Single Flush Volume", value: "4-6L" },
        { label: "Design Style", value: "Vintage Style" },
        { label: "Height", value: "400mm" },
        { label: "Soft Closing Lid", value: "Yes" },
        { label: "Toilet Flushing Method", value: "Siphonic" },
        { label: "Load Capacity", value: "Above 100KG-150KG" },
        { label: "Water Heating Type", value: "Instant Heating" },
        { label: "Flushing Noise", value: "30dB" },
        { label: "Width", value: "400mm" },
        { label: "Water Temperature Gears", value: "4" },
        { label: "Main Material", value: "Ceramic" },
        { label: "Installation Service", value: "Paid Installation Supported" },
        { label: "Water Temperature Adjustment", value: "Remote Control Button Adjustment" },
        { label: "Drying Fan Speed Gears", value: "4" },
        { label: "Drainage Direction", value: "Floor Drain" },
        { label: "Sterilization Method", value: "Electrolyzed Water Sterilization" },
        { label: "Smart Type", value: "Other Smart" },
        { label: "Installation Type", value: "Floor Mounted" },
        { label: "Lighting Function", value: "Night Lighting Supported" },
        { label: "Tank Capacity", value: "6L" },
        { label: "Lid Opening Sensor", value: "Microwave Radar" },
        { label: "Seat Temperature Adjustment", value: "Remote Control Button Adjustment" },
        { label: "Drying Air Temperature Gears", value: "4" },
        { label: "Seat Material", value: "PP" },
        { label: "Warranty Period", value: "3 Years" },
        { label: "Deodorization Function", value: "Aroma Foam Shield" },
        { label: "Material", value: "Ceramic" },
        { label: "Lid Material", value: "Ceramic" },
        { label: "Waterproof Rating", value: "IPX4" },
        { label: "Suitable For", value: "Adults" },
        { label: "Flushing Pressure Gears", value: "4" },
        { label: "Flush Control Type", value: "Remote + APP + Sensor + Foot Kick + Side Control" },
        { label: "Nozzle Material", value: "Stainless Steel" },
        { label: "Length", value: "695mm" },
        { label: "Water Pressure Requirement", value: "0.1-0.75MPa" },
        { label: "Warm Air Drying Adjustment", value: "Remote + Side Control + APP" },
        { label: "Nozzle Self-Cleaning", value: "Supported" }
      ],
      imgs: [
        require("../assets/images/Home/21.jpg"),
        require("../assets/images/Home/21.1.jpg"),
        require("../assets/images/Home/21.2.jpg"),
        require("../assets/images/Home/21.3.jpg"),
        require("../assets/images/Home/21.4.jpg"),
        require("../assets/images/Home/21.5.jpg"),
      ]
    },
  },
  {
    id: 'Home0022',
    type: 'Home',
    homeImg: require("../assets/images/Home/22.jpg"),
    obj1: {
      title: 'French retro imitation stone pattern integrated smart toilet, siphonic type with built-in water tank, no water pressure limitation',
      money: '230.95',
      color: ['Light brown'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'Light brown' },
        { label: "Minimal Rough-in", value: "350mm" },
        { label: "Water Efficiency Level", value: "Other" },
        { label: "Safety Protection", value: "IPX4 Waterproof" },
        { label: "Additional Functions", value: "Mobile Control, Antibacterial Seat, Drying & Sterilization, Seat Heating, Flush Pressure Adjustment, Auto Flush, Nozzle Self-Cleaning, No Water Pressure Limit, Posterior Wash, Feminine Wash" },
        { label: "Design Style", value: "Vintage Style" },
        { label: "Height", value: "400mm" },
        { label: "Flushing Method", value: "Siphon + Power Assist" },
        { label: "Water Heating Type", value: "Instant Heating" },
        { label: "Width", value: "400mm" },
        { label: "Main Material", value: "Ceramic" },
        { label: "Installation Service", value: "Installation Supported" },
        { label: "Water Temperature Adjustment", value: "Remote Control Button Adjustment" },
        { label: "Drainage Type", value: "Floor Drain" },
        { label: "Installation Type", value: "Floor Mounted" },
        { label: "Lighting Function", value: "Night Lighting Supported" },
        { label: "Lid Opening Sensor", value: "Foot Kick" },
        { label: "Waterproof Rating", value: "IPX4" },
        { label: "Suitable For", value: "Adults" },
        { label: "Flush Control Type", value: "Side Button" },
        { label: "Load Capacity", value: "40kg" },
        { label: "Length", value: "695mm" },
        { label: "Water Pressure Requirement", value: "0.1-0.75MPa" },
        { label: "Nozzle Self-Cleaning", value: "Supported" }
      ],
      imgs: [
        require("../assets/images/Home/22.jpg"),
        require("../assets/images/Home/22.1.jpg"),
        require("../assets/images/Home/22.2.jpg"),
        require("../assets/images/Home/22.3.jpg"),
        require("../assets/images/Home/22.4.jpg"),
        require("../assets/images/Home/22.5.jpg"),
      ]
    },
  },
  {
    id: 'Home0023',
    type: 'Home',
    homeImg: require("../assets/images/Home/23.jpg"),
    obj1: {
      title: 'Smart toilet with no water pressure restriction for household use',
      money: '411.95',
      color: ['Gunmetal gray'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Product Grade', value: 'Brand New' },
        { label: 'Quantity', value: '1 Piece' },
        { label: "Additional Functions", value: "Mobile Control" },
        { label: "Water Efficiency Level", value: "Level 2" },
        { label: "Model", value: "K5" },
        { label: "Minimal Rough-in", value: "400mm 300mm 350mm 250mm" },
        { label: "Safety Protection", value: "Leakage Protection" },
        { label: "Lighting Function", value: "Night Lighting Supported" },
        { label: "Lid Opening Sensor", value: "Foot Kick" },
        { label: "Height", value: "470mm" },
        { label: "Seat Material", value: "ABS" },
        { label: "Material", value: "ABS" },
        { label: "Flushing Method", value: "Floor Drain" },
        { label: "Water Heating Type", value: "Instant Heating" },
        { label: "Width", value: "425mm" },
        { label: "Flush Control Type", value: "Remote Control" },
        { label: "Main Material", value: "Plastic" },
        { label: "Length", value: "660mm" },
        { label: "Drainage Direction", value: "Floor Drain" },
        { label: "Water Pressure Requirement", value: "0.15-0.75MPa" },
        { label: "Nozzle Self-Cleaning", value: "Supported" },
        { label: 'Color Category', value: 'Gunmetal gray' }
      ],
      imgs: [
        require("../assets/images/Home/23.jpg"),
        require("../assets/images/Home/23.1.jpg"),
        require("../assets/images/Home/23.2.jpg"),
        require("../assets/images/Home/23.3.jpg"),
        require("../assets/images/Home/23.4.jpg"),
        require("../assets/images/Home/23.5.jpg"),
      ]
    },
  },
  {
    id: 'Home0024',
    type: 'Home',
    homeImg: require("../assets/images/Home/24.jpg"),
    obj1: {
      title: 'Retro imitation stone craft intelligent toilet',
      money: '259.95',
      color: ['Ma Shi Brown'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'Ma Shi Brown' },
        { label: 'Quantity', value: '1 Piece' },
        { label: "Minimal Rough-in", value: "350mm" },
        { label: "Water Efficiency Level", value: "Other" },
        { label: "Safety Protection", value: "IPX4 Waterproof" },
        { label: "Additional Functions", value: "Mobile Control, Antibacterial Seat, Drying & Sterilization, Seat Heating, Flush Pressure Adjustment, Auto Flush When Leaving, Nozzle Self-Cleaning, No Water Pressure Limit, Posterior Wash, Feminine..." },
        { label: "Design Style", value: "Vintage Style" },
        { label: "Height", value: "400mm" },
        { label: "Soft Closing Lid", value: "Yes" },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Flushing Method", value: "Jet Siphonic" },
        { label: "Water Heating Type", value: "Instant Heating" },
        { label: "Width", value: "400mm" },
        { label: "Main Material", value: "Ceramic" },
        { label: "Installation Service", value: "Installation Supported" },
        { label: "Water Temperature Adjustment", value: "Remote Control Adjustment" },
        { label: "Drainage Direction", value: "Floor Drain" },
        { label: "Installation Type", value: "Floor Mounted" },
        { label: "Waterproof Rating", value: "IPX4" },
        { label: "Suitable For", value: "Adults" },
        { label: "Flush Control Type", value: "Auto Flush When Leaving" },
        { label: "Load Capacity", value: "40kg" },
        { label: "Length", value: "695mm" },
        { label: "Water Pressure Requirement", value: "0.1-0.75MPa" }
      ],
      imgs: [
        require("../assets/images/Home/24.jpg"),
        require("../assets/images/Home/24.1.jpg"),
        require("../assets/images/Home/24.2.jpg"),
        require("../assets/images/Home/24.3.jpg"),
        require("../assets/images/Home/24.4.jpg"),
        require("../assets/images/Home/24.5.jpg"),
      ]
    },
  },
  {
    id: 'Home0025',
    type: 'Home',
    homeImg: require("../assets/images/Home/25.jpg"),
    obj1: {
      title: 'Smart toilet seat with automatic drying and deodorizing function, household automatic opening cover plate, full-function flush device',
      money: '99.95',
      color: ['Titanium Silver'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'Titanium Silver' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Shell Material", value: "Stainless Steel" },
        { label: "Shape", value: "Long Cylindrical" },
        { label: "Item Number", value: "TC-Z17" },
        { label: "Applicable Scenario", value: "Home Use" },
        { label: 'Quantity', value: '1 Piece' },
        { label: "Smart Sensor Double Door", value: "Supported" },
        { label: "USB Charging", value: "1500mA" },
        { label: "Pull-out Automatic Packing Function", value: "Supported" },
        { label: "Warranty", value: "1 Year" },
        { label: "Direct Charging Support", value: "Yes" },
        { label: "Sterilization Function", value: "Supported" }
      ],
      imgs: [
        require("../assets/images/Home/25.jpg"),
        require("../assets/images/Home/25.1.jpg"),
        require("../assets/images/Home/25.2.jpg"),
        require("../assets/images/Home/25.3.jpg"),
        require("../assets/images/Home/25.4.jpg"),
        require("../assets/images/Home/25.5.jpg"),
        require("../assets/images/Home/25.6.jpg"),
      ]
    },
  },
  {
    id: 'Home0026',
    type: 'Home',
    homeImg: require("../assets/images/Home/26.jpg"),
    obj1: {
      title: 'Smart toilet seat with automatic drying and deodorizing function, household automatic opening cover plate, full-function flush device',
      money: '49.95',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'White' },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Capacity", value: "36L" },
        { label: "Power Supply", value: "4 x AA Batteries" },
        { label: "Battery Capacity", value: "NA" },
        { label: "Net Weight", value: "4.19kg" },
        { label: "Gross Weight", value: "5.56kg" },
        { label: "Product Dimensions", value: "L 42.5 x W 28.6 x H 63" },
        { label: "Package Dimensions", value: "L 45 x W 32.5 x H 49" },
        { label: "Applicable Scenarios", value: "Bathroom / Living Room" },
        { label: 'Quantity', value: '1 Piece' },
        { label: "Shell Material", value: "Stainless Steel" },
        { label: "Shape", value: "Long Cylindrical" }
      ],
      imgs: [
        require("../assets/images/Home/26.jpg"),
        require("../assets/images/Home/26.1.jpg"),
        require("../assets/images/Home/26.2.jpg"),
        require("../assets/images/Home/26.3.jpg"),
      ]
    },
  },
  {
    id: 'Home0027',
    type: 'Home',
    homeImg: require("../assets/images/Home/27.jpg"),
    obj1: {
      title: 'Oximeter finger clamp oxygen saturation clamp household fingertip blood oxygen saturation heart rate finger pulse oxygen medical detector',
      money: '39.00',
      color: ['White'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'White' },
        { label: "Medical Device Name", value: "Fingertip Pulse Oximeter" },
        { label: "Applicable Part", value: "Finger" },
        { label: "Applicable User", value: "Adult" },
        { label: 'Product Grade', value: 'Brand New' },
        { label: "Value-added Service", value: "3-Year Warranty" },
        { label: "Application", value: "Blood Oxygen Test" },
        { label: 'Quantity', value: '1 Piece' },
        { label: "Purchase Highlights", value: "Measure Blood Oxygen Concentration, Blood Oxygen Saturation, Oximeter Clip" },
        { label: "Symptom", value: "Measure Blood Oxygen Concentration" },
        { label: "Color Category", value: "Fingertip Pulse Oximeter" },

      ],
      imgs: [
        require("../assets/images/Home/27.jpg"),
        require("../assets/images/Home/27.1.jpg"),
        require("../assets/images/Home/27.2.jpg"),
        require("../assets/images/Home/27.3.jpg"),
        require("../assets/images/Home/27.4.jpg"),
        require("../assets/images/Home/27.5.jpg"),
      ]
    },
  },
  {
    id: 'Home0028',
    type: 'Home',
    homeImg: require("../assets/images/Home/28.jpg"),
    obj1: {
      title: 'Intelligent Carved Cast Aluminum Armor Door with Dual Cameras, Anti-Theft Entrance Door, Integrated Entry Door',
      money: '8990.99',
      color: ['Starry Gray'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'Starry Gray' },
        { "label": "Main Material", "value": "Precision Carved Aluminum" },
        { "label": "On-site Measurement", "value": "Free On-site Measurement" },
        { "label": "Total Door Weight", "value": "85kg" },
        { "label": "Pricing Unit", "value": "Set" },
        { "label": "Overlord Lock Support", "value": "Supports Overlord Lock Body" },
        { "label": "Applicable Space", "value": "Entrance Door, Self-built House, Community, Villa Door" },
        { "label": "Installation Service", "value": "Professional Installation" },
        { "label": "Alarm Method", "value": "Mobile Phone Message Alert" },
        { "label": "Full Set Support", "value": "No" },
        { "label": "Style", "value": "Light Luxury Style" },
        { "label": "Customization Support", "value": "Supports Customization" },
        { "label": "Award Type", "value": "Smart Door Technology Standard Drafting Unit" },
        { "label": "Production Cycle", "value": "30 Days" },
        { "label": "Warranty Period", "value": "12 Months" },
        { "label": "Lock Cylinder Grade", "value": "Class C" },
        { "label": "Anti-pry Layers", "value": "8 Layers" },
        { "label": "Frame Material", "value": "Stainless Steel" },
        { "label": "Door Leaf Filler", "value": "Polyurethane Foam" },
        { "label": "Sound Insulation Grade", "value": "25" },
        { "label": "Surface Treatment Process", "value": "Fluorocarbon Spraying" },
        { "label": "Brand", "value": "TENON/Asia Pacific Tianneng" },
        { "label": "Model", "value": "M96" },
        { "label": "Province", "value": "Guangdong Province" },
        { "label": "City", "value": "Guangzhou City" },
        { "label": "Installation Method", "value": "Bolt Fixation" },
        { "label": "Frame Thickness", "value": "90mm" },
        { "label": "Anti-theft Grade", "value": "Grade 4" },
        { "label": "Place of Origin", "value": "Mainland China" },
        { "label": "Pre-embedding Requirement", "value": "Not Required" },
        { "label": "Quality Inspection Standard", "value": "GB 17565" },
        { "label": "Anti-pry Points", "value": "8 Pieces" },
        { "label": "Door Leaf Thickness", "value": "90mm" },
        { "label": "Fire Protection Grade", "value": "Grade B" }

      ],
      imgs: [
        require("../assets/images/Home/28.jpg"),
        require("../assets/images/Home/28.1.jpg"),
        require("../assets/images/Home/28.2.jpg"),
        require("../assets/images/Home/28.3.jpg"),
        require("../assets/images/Home/28.4.jpg"),
        require("../assets/images/Home/28.5.jpg"),
      ]
    },
  },
  {
    id: 'Home0029',
    type: 'Home',
    homeImg: require("../assets/images/Home/29.jpg"),
    obj1: {
      title: 'Dual camera intelligent lock, facial palm vein, finger vein, smart door lock, entrance door anti-theft',
      money: '309.95',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'Black' },
        { label: 'Product Grade', value: 'Brand New' },
        { "label": "Panel & Handle Material", "value": "Aluminum Alloy" },
        { "label": "Electronic Type", "value": "Password Lock" },
        { "label": "Door Opening Direction Requirement", "value": "Universal Door Opening Direction" },
        { "label": "Dummy Password Support", "value": "Supports Dummy Password" },
        { "label": "Emergency Power Interface", "value": "Type-C Interface" },
        { "label": "Lock Cylinder Grade", "value": "Class C" },
        { "label": "Warranty Period", "value": "3 Years" },
        { "label": "Remote Control Capability", "value": "Supports Remote Control" },
        { "label": "Peephole Function", "value": "With Peephole & Voice Changer, With Peephole & Remote Video Intercom, With Peephole & Dual Camera Design, With Peephole, With Peephole & Night Vision..." },
        { "label": "Network Protocol Type", "value": "Wi-Fi" },
        { label: 'Quantity', value: '1 Piece' },
        { "label": "Anti-pry Alarm Function", "value": "Equipped with Anti-pry Alarm Function" },
        { "label": "Number of Screens", "value": "1" },
        { "label": "Deadbolt Hook Compatibility", "value": "Supports Deadbolt Hook" },
        { "label": "Power Type", "value": "Lithium Battery" },
        { "label": "Data Storage Type", "value": "Cloud Storage" },
        { "label": "AI Function", "value": "Equipped with AI Function" },
        { "label": "Temporary Password Generation", "value": "Supports Temporary Password Generation" }
      ],
      imgs: [
        require("../assets/images/Home/29.jpg"),
        require("../assets/images/Home/29.1.jpg"),
        require("../assets/images/Home/29.2.jpg"),
        require("../assets/images/Home/29.3.jpg"),
        require("../assets/images/Home/29.4.jpg"),
        require("../assets/images/Home/29.5.jpg"),
      ]
    },
  },
  {
    id: 'Home0030',
    type: 'Home',
    homeImg: require("../assets/images/Home/30.jpg"),
    obj1: {
      title: 'Intelligent door lock refers to vein password lock',
      money: '189.95',
      color: ['Black'],
      quantity: 1
    },
    obj2: {
      details: [
        { label: 'Color Category', value: 'Black' },
        { "label": "Panel & Handle Material", "value": "Flame Retardant PC + Aluminum Alloy Handle" },
        { "label": "Electronic Type", "value": "Password Lock" },
        { "label": "Dummy Password Support", "value": "Supports Dummy Password" },
        { "label": "Emergency Power Interface", "value": "Type-C Interface" },
        { label: 'Product Grade', value: 'Brand New' },
        { "label": "Lock Cylinder Grade", "value": "Class C" },
        { "label": "Remote Control Capability", "value": "No Remote Control Support" },
        { "label": "Peephole Function", "value": "No Peephole Function" },
        { label: 'Quantity', value: '1 Piece' },
        { "label": "Network Protocol Type", "value": "Wi-Fi" },
        { "label": "Anti-pry Alarm Function", "value": "Equipped with Anti-pry Alarm Function" },
        { "label": "Number of Screens", "value": "0" },
        { "label": "Deadbolt Hook Compatibility", "value": "Supports Deadbolt Hook" },
        { "label": "Power Type", "value": "Lithium Battery" },
        { "label": "AI Function", "value": "No AI Function" },
        { "label": "Temporary Password Generation", "value": "Supports Temporary Password Generation" },


      ],
      imgs: [
        require("../assets/images/Home/30.jpg"),
        require("../assets/images/Home/30.1.jpg"),
        require("../assets/images/Home/30.2.jpg"),
        require("../assets/images/Home/30.3.jpg"),
        require("../assets/images/Home/30.4.jpg"),
        require("../assets/images/Home/30.5.jpg"),
      ]
    },
  },
  // {
  //   id: 'Home0027',
  //   type: 'Home',
  //   homeImg: require("../assets/images/Home/27.jpg"),
  //   obj1: {
  //     title: '1',
  //     money: '39.00',
  //     color: ['White'],
  //     quantity: 1
  //   },
  //   obj2: {
  //     details: [
  //       { label: 'Color Category', value: 'White' },
  //       { label: 'Product Grade', value: 'Brand New' },
  //       { label: 'Quantity', value: '1 Piece' },

  //     ],
  //     imgs: [
  //       require("../assets/images/Home/27.jpg"),
  //       require("../assets/images/Home/27.1.jpg"),
  //       require("../assets/images/Home/27.2.jpg"),
  //       require("../assets/images/Home/27.3.jpg"),
  //       require("../assets/images/Home/27.4.jpg"),
  //       require("../assets/images/Home/27.5.jpg"),
  //     ]
  //   },
  // },

]